import { ApiState, ViewModel, valueDisplay, mapValueToModel, ModelApiClient, mapParamsToDto, getMessageForError, convertToModel, BehaviorFlags, modelDisplay, ViewModelFactory, convertValueToModel, getDefaultTimeZone, parseDateUserInput, parseValue, ListViewModel, HiddenAreas, useBindToQueryString, propDisplay, ServiceViewModel, mapQueryToParams, ListParameters, bindKeyToRouteOnCreate, bindToQueryString } from "coalesce-vue";
import { defineComponent, mergeDefaults, camelize, computed, openBlock, createBlock, TransitionGroup, normalizeClass, withCtx, createElementVNode, createVNode, createElementBlock, Fragment, renderList, toDisplayString, createCommentVNode, normalizeStyle, renderSlot, createTextVNode, mergeProps, inject, useAttrs, useSlots, h, ref, watch, nextTick, unref, withModifiers, withDirectives, vModelText, withKeys, mergeModels, useModel, onMounted, toHandlerKey, toRaw, reactive, resolveComponent, getCurrentInstance, onUnmounted, toRef } from "vue";
import { VAlert, VExpandTransition, VProgressLinear, VIcon, VBtn, VTextField, VSelect, VField, VFadeTransition, VProgressCircular, VListItemTitle, VListItemSubtitle, VListItem, VList, VSheet, VMenu, VInput, VAutocomplete, VCombobox, VFab, VDatePicker, VDivider, VCard, VFileInput, VCheckbox, VSwitch, VTextarea, VToolbarTitle, VSpacer, VDefaultsProvider, VToolbar, VTable, VCardText, VContainer, VCol, VRow, VForm, VCardActions, VExpansionPanelTitle, VExpansionPanelText, VExpansionPanel, VExpansionPanels, VBadge, VCardTitle, VBtnToggle, VChip } from "vuetify/components";
import { format, isValid, setMinutes, set, isSameDay, getHours, endOfHour, startOfHour, setHours, startOfDay, endOfDay, parse, setDate, setYear, setMonth, differenceInMilliseconds } from "date-fns";
import { format as format$1, toZonedTime, fromZonedTime } from "date-fns-tz";
import { useRouter, useRoute } from "vue-router";
const _hoisted_1$d = { key: "error" };
const _hoisted_2$c = { key: 0 };
const _hoisted_3$b = ["textContent"];
const _hoisted_4$9 = {
  key: "normal",
  class: "c-loader-status--content"
};
class Flags {
  constructor() {
    this.progress = true;
    this["initial-progress"] = true;
    this["secondary-progress"] = true;
    this["loading-content"] = true;
    this["error-content"] = true;
    this["initial-content"] = true;
  }
}
const _sfc_main$n = /* @__PURE__ */ defineComponent({
  ...{
    name: "c-loader-status"
  },
  __name: "c-loader-status",
  props: /* @__PURE__ */ mergeDefaults({
    loaders: {},
    progressPlaceholder: { type: Boolean },
    progressAbsolute: { type: Boolean },
    height: {},
    color: {},
    noProgress: { type: Boolean },
    noInitialProgress: { type: Boolean },
    noSecondaryProgress: { type: Boolean },
    noLoadingContent: { type: Boolean },
    noErrorContent: { type: Boolean },
    noInitialContent: { type: Boolean }
  }, {
    progressPlaceholder: true,
    height: 10,
    color: "primary",
    // Prevent our flags from defaulting to `false`. We need them to default to `undefined`
    // so we can detect if they were specified at all.
    ...Object.fromEntries(
      Object.entries(new Flags()).flatMap((f) => [
        // [camelize(f[0]), undefined],
        [camelize("no-" + f[0]), void 0]
      ])
    )
  }),
  setup(__props, { expose: __expose }) {
    const props = __props;
    const baselineFlags = computed(() => {
      const flags = new Flags();
      for (const key in flags) {
        const noFlag = camelize("no-" + key);
        const flagValue = props[noFlag];
        if (flagValue != null) flags[key] = !flagValue;
      }
      return Object.freeze(flags);
    });
    const loaderFlags = computed(() => {
      const ret = [];
      let loaders = props.loaders;
      if (Array.isArray(loaders)) {
        loaders = { "": loaders };
      } else if (loaders == null) {
        loaders = { "": [] };
      } else if (loaders instanceof ApiState) {
        loaders = { "": [loaders] };
      }
      for (const flagsStr in loaders) {
        let loadersForFlags = loaders[flagsStr];
        if (!Array.isArray(loadersForFlags)) {
          loadersForFlags = [loadersForFlags];
        }
        let flags = baselineFlags.value;
        if (flagsStr != "") {
          const flagsArr = flagsStr.split(" ");
          flags = { ...flags };
          if (flagsArr.length) {
            for (const flagName in flags) {
              if (flagsArr.includes(flagName)) {
                flags[flagName] = true;
              } else if (flagsArr.includes("no-" + flagName)) {
                flags[flagName] = false;
              }
            }
          }
        }
        for (const loader of loadersForFlags) {
          if (loader) {
            ret.push([loader, flags]);
          }
        }
      }
      return ret;
    });
    const errorMessages = computed(() => {
      return loaderFlags.value.filter((f) => f[0].wasSuccessful === false).map((f) => f[0].message);
    });
    const showLoading = computed(() => {
      return loaderFlags.value.some((f) => {
        const [loader, flags] = f;
        if (!flags.progress) return false;
        const isLoading = loader.isLoading;
        return flags["initial-progress"] && isLoading && loader.wasSuccessful == null || flags["secondary-progress"] && isLoading && loader.wasSuccessful != null;
      });
    });
    const usePlaceholder = computed(() => {
      return props.progressPlaceholder && loaderFlags.value.some(
        (f) => (
          // Obviously don't need a progress placeholder if progress is off:
          f[1].progress && // If secondary progress is off, the progress bar will never be shown
          // once any content has been obtained, so there's no need to keep a placeholder.
          f[1]["secondary-progress"] && // If loading content was off then the progressbar will just take the place of the content,
          // so a placeholder is only needed if loading-content is on.
          f[1]["loading-content"]
        )
      );
    });
    const showContent = computed(() => {
      return loaderFlags.value.every(([loader, flags]) => {
        if (!flags["loading-content"] && loader.isLoading) {
          return false;
        }
        if (!flags["error-content"] && loader.wasSuccessful === false) {
          return false;
        }
        if (
          // initial content is off, and either:
          !flags["initial-content"] && // loader has not yet loaded
          (loader.wasSuccessful == null || // or loader has loaded, but it errored and there's no current result
          // (implying it has never successfully loaded).
          loader.wasSuccessful === false && !loader.hasResult)
        ) {
          return false;
        }
        return true;
      });
    });
    __expose({ loaderFlags });
    return (_ctx, _cache) => {
      const _component_v_alert = VAlert;
      const _component_v_expand_transition = VExpandTransition;
      const _component_v_progress_linear = VProgressLinear;
      return openBlock(), createBlock(TransitionGroup, {
        class: normalizeClass(["c-loader-status c-loader-status--transition-group", {
          "has-progress-placeholder": usePlaceholder.value
        }]),
        name: "c-loader-status-fade",
        mode: "out-in",
        tag: "div"
      }, {
        default: withCtx(() => [
          createElementVNode("div", _hoisted_1$d, [
            createVNode(_component_v_expand_transition, null, {
              default: withCtx(() => [
                errorMessages.value.length ? (openBlock(), createElementBlock("div", _hoisted_2$c, [
                  createVNode(_component_v_alert, {
                    modelValue: true,
                    type: "error",
                    class: "c-loader-status--errors"
                  }, {
                    default: withCtx(() => [
                      createElementVNode("ul", null, [
                        (openBlock(true), createElementBlock(Fragment, null, renderList(errorMessages.value, (message, i) => {
                          return openBlock(), createElementBlock("li", {
                            key: "message-" + i,
                            class: "c-loader-status--error-message",
                            textContent: toDisplayString(message)
                          }, null, 8, _hoisted_3$b);
                        }), 128))
                      ])
                    ]),
                    _: 1
                  })
                ])) : createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          createVNode(TransitionGroup, {
            key: "loading",
            class: normalizeClass(["c-loader-status--transition-group c-loader-status--progress-group", { absolute: _ctx.progressAbsolute }]),
            name: "c-loader-status-fade",
            mode: "out-in",
            tag: "div",
            style: normalizeStyle({
              "--c-loader-status-progress-height": (usePlaceholder.value || showLoading.value ? _ctx.height : 0) + "px"
            })
          }, {
            default: withCtx(() => [
              showLoading.value ? (openBlock(), createBlock(_component_v_progress_linear, {
                key: "progress",
                class: "c-loader-status--progress",
                indeterminate: "",
                height: _ctx.height,
                color: _ctx.color
              }, null, 8, ["height", "color"])) : createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["class", "style"]),
          showContent.value ? (openBlock(), createElementBlock("div", _hoisted_4$9, [
            renderSlot(_ctx.$slots, "default")
          ])) : createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});
const _hoisted_1$c = { class: "c-list-page" };
const _hoisted_2$b = { class: "text-no-wrap hidden-sm-and-up" };
const _hoisted_3$a = {
  key: 0,
  class: "text-no-wrap ml-0"
};
const _sfc_main$m = /* @__PURE__ */ defineComponent({
  __name: "c-list-page",
  props: {
    list: {}
  },
  setup(__props) {
    const props = __props;
    const effectivePage = computed(() => {
      return Math.min(props.list.$page, props.list.$pageCount ?? props.list.$page);
    });
    return (_ctx, _cache) => {
      const _component_v_icon = VIcon;
      const _component_v_btn = VBtn;
      const _component_v_text_field = VTextField;
      return openBlock(), createElementBlock("div", _hoisted_1$c, [
        createVNode(_component_v_btn, {
          variant: "outlined",
          size: "x-small",
          icon: "",
          onClick: _cache[0] || (_cache[0] = ($event) => _ctx.list.$page = effectivePage.value - 1),
          disabled: !_ctx.list.$hasPreviousPage,
          title: "Previous Page"
        }, {
          default: withCtx(() => [
            createVNode(_component_v_icon, { size: "small" }, {
              default: withCtx(() => [
                createTextVNode("$prev")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["disabled"]),
        createTextVNode(" Page "),
        createVNode(_component_v_text_field, {
          class: "pt-0 d-none d-sm-inline-block current-page",
          type: "number",
          min: "1",
          max: _ctx.list.$load.pageCount === -1 ? null : _ctx.list.$load.pageCount,
          modelValue: effectivePage.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.list.$page = +$event),
          "hide-details": "",
          density: "compact",
          variant: "outlined",
          title: "Current Page Number"
        }, null, 8, ["max", "modelValue"]),
        createElementVNode("span", _hoisted_2$b, toDisplayString(_ctx.list.$page), 1),
        _ctx.list.$load.pageCount !== -1 ? (openBlock(), createElementBlock("span", _hoisted_3$a, "of " + toDisplayString(_ctx.list.$load.pageCount), 1)) : createCommentVNode("", true),
        createVNode(_component_v_btn, {
          variant: "outlined",
          size: "x-small",
          icon: "",
          onClick: _cache[2] || (_cache[2] = ($event) => _ctx.list.$page = effectivePage.value + 1),
          disabled: !_ctx.list.$hasNextPage,
          title: "Next Page"
        }, {
          default: withCtx(() => [
            createVNode(_component_v_icon, { size: "small" }, {
              default: withCtx(() => [
                createTextVNode("$next")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["disabled"])
      ]);
    };
  }
});
const _sfc_main$l = defineComponent({
  name: "c-list-range-display",
  props: {
    list: { required: true, type: Object }
  },
  computed: {
    rangeStart() {
      const list = this.list;
      const page = list.$load.page ?? 0;
      const pageSize = list.$load.pageSize ?? 0;
      if (!list.$load.totalCount) {
        return 0;
      }
      return (page - 1) * pageSize + 1;
    },
    rangeEnd() {
      const list = this.list;
      if (!list.$load.totalCount) {
        return 0;
      }
      return this.rangeStart + (list.$modelOnlyMode ? list.$modelItems : list.$items).length - 1;
    }
  }
});
const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const _hoisted_1$b = { class: "c-list-range-display" };
const _hoisted_2$a = { class: "c-list-range-display--start" };
const _hoisted_3$9 = { class: "c-list-range-display--end" };
const _hoisted_4$8 = { class: "c-list-range-display--total" };
function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("span", _hoisted_1$b, [
    createElementVNode("span", _hoisted_2$a, toDisplayString(_ctx.rangeStart), 1),
    createTextVNode(" - "),
    createElementVNode("span", _hoisted_3$9, toDisplayString(_ctx.rangeEnd), 1),
    _ctx.list.$load.totalCount !== -1 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
      createTextVNode(" of "),
      createElementVNode("span", _hoisted_4$8, toDisplayString(_ctx.list.$load.totalCount), 1)
    ], 64)) : createCommentVNode("", true)
  ]);
}
const __unplugin_components_5 = /* @__PURE__ */ _export_sfc(_sfc_main$l, [["render", _sfc_render$7]]);
const _sfc_main$k = defineComponent({
  name: "c-list-page-size",
  props: {
    list: { required: true, type: Object },
    items: {
      default() {
        return [10, 25, 100];
      }
    }
  },
  computed: {
    selectBinds() {
      return {
        variant: "outlined",
        "hide-details": true,
        density: "compact",
        items: this.items,
        class: "c-list-page-size--dropdown"
      };
    }
  }
});
const _hoisted_1$a = { class: "c-list-page-size" };
const _hoisted_2$9 = /* @__PURE__ */ createElementVNode("span", { class: "d-none d-sm-inline-block" }, " Page Size ", -1);
const _hoisted_3$8 = { title: "Current Page Size" };
function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_select = VSelect;
  return openBlock(), createElementBlock("div", _hoisted_1$a, [
    _hoisted_2$9,
    createElementVNode("span", _hoisted_3$8, [
      _ctx.$vuetify.display.smAndUp ? (openBlock(), createBlock(_component_v_select, mergeProps({ key: "no-label" }, _ctx.selectBinds, {
        modelValue: _ctx.list.$params.pageSize,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.list.$params.pageSize = $event)
      }), null, 16, ["modelValue"])) : (openBlock(), createBlock(_component_v_select, mergeProps({ key: "with-label" }, _ctx.selectBinds, {
        label: "Page Size",
        modelValue: _ctx.list.$params.pageSize,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.list.$params.pageSize = $event)
      }), null, 16, ["modelValue"]))
    ])
  ]);
}
const __unplugin_components_9 = /* @__PURE__ */ _export_sfc(_sfc_main$k, [["render", _sfc_render$6]]);
const _sfc_main$j = defineComponent({
  name: "c-list-pagination",
  props: {
    list: { required: true, type: Object },
    pageSizes: { required: false, type: Array }
  }
});
const _hoisted_1$9 = { class: "c-list-pagination grey--text" };
function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_c_list_page_size = __unplugin_components_9;
  const _component_c_list_range_display = __unplugin_components_5;
  const _component_c_list_page = _sfc_main$m;
  return openBlock(), createElementBlock("div", _hoisted_1$9, [
    createElementVNode("div", null, [
      createVNode(_component_c_list_page_size, {
        list: _ctx.list,
        items: _ctx.pageSizes
      }, null, 8, ["list", "items"])
    ]),
    createElementVNode("div", null, [
      createVNode(_component_c_list_range_display, { list: _ctx.list }, null, 8, ["list"])
    ]),
    createElementVNode("div", null, [
      createVNode(_component_c_list_page, { list: _ctx.list }, null, 8, ["list"])
    ])
  ]);
}
const __unplugin_components_3 = /* @__PURE__ */ _export_sfc(_sfc_main$j, [["render", _sfc_render$5], ["__scopeId", "data-v-22407041"]]);
const metadataKey = Symbol("coalesce metadata");
function useMetadata() {
  return inject(metadataKey);
}
function getValueMetaAndOwner(forVal, model, $metadata) {
  const valueMeta = getValueMeta(forVal, model == null ? void 0 : model.$metadata, $metadata);
  if (model instanceof ApiState && "args" in model && valueMeta && valueMeta.name in model.args) {
    model = model.args;
  }
  return { valueMeta, valueOwner: model };
}
function getValueMeta(forVal, modelMeta, $metadata) {
  if (!forVal) {
    return null;
  }
  if (typeof forVal != "string") {
    return forVal;
  }
  if (forVal.length === 0) {
    throw `prop 'for' must not be an empty string`;
  }
  if (modelMeta && "props" in modelMeta) {
    const matchedProp = modelMeta.props[forVal];
    if (matchedProp) {
      return matchedProp;
    }
  }
  const forParts = forVal.split(".");
  let tail = void 0;
  let tailKind = void 0;
  if (modelMeta) {
    if ("params" in modelMeta) {
      tail = modelMeta;
      tailKind = "method";
    } else if (modelMeta.type == "object" || modelMeta.type == "model" || modelMeta.type == "dataSource") {
      tail = modelMeta;
      tailKind = "type";
    }
  }
  $metadata ?? ($metadata = useMetadata());
  for (let i = 0; i < forParts.length; i++) {
    const forPart = forParts[i];
    const forPartNext = forParts[i + 1];
    if (i == 0 && $metadata) {
      if (forPart in $metadata.types) {
        tail = $metadata.types[forPart];
        tailKind = "type";
        continue;
      }
      if (forPart in $metadata.enums) {
        const type = $metadata.enums[forPart];
        tail = {
          type: type.type,
          displayName: type.displayName,
          name: "",
          role: "value",
          typeDef: type
        };
        tailKind = "value";
        continue;
      }
    }
    if (tailKind == "type") {
      const type = tail;
      if (type.props[forPart]) {
        tail = type.props[forPart];
        tailKind = "property";
        continue;
      }
      if (type.type == "model" && type.methods[forPart]) {
        tail = type.methods[forPart];
        tailKind = "method";
        continue;
      }
      if (forPart == "props" && type.props[forPartNext]) {
        i++;
        tail = type.props[forPartNext];
        tailKind = "property";
        continue;
      }
      if (forPart == "methods" && type.type == "model" && type.methods[forPartNext]) {
        i++;
        tail = type.methods[forPartNext];
        tailKind = "method";
        continue;
      }
    } else if (tailKind == "method") {
      const method = tail;
      if (method.params[forPart]) {
        tail = method.params[forPart];
        tailKind = "value";
        continue;
      }
      if (forPart == "params" && method.params[forPartNext]) {
        i++;
        tail = method.params[forPartNext];
        tailKind = "value";
        continue;
      }
    }
    throw Error(
      `Could not resolve token '${forPart}'${forVal != forPart ? " in " + forVal : ""} from ${tailKind} '${tail == null ? void 0 : tail.name}'`
    );
  }
  if (!tail) {
    throw Error(`Could not find any metadata with for specifier '${forVal}'`);
  }
  switch (tailKind) {
    case "method":
      return tail;
    case "type":
      const type = tail;
      switch (type.type) {
        case "model":
          return {
            type: type.type,
            displayName: type.displayName,
            name: "",
            role: "referenceNavigation",
            typeDef: type
          };
        case "object":
          return {
            type: type.type,
            displayName: type.displayName,
            name: "",
            role: "value",
            typeDef: type
          };
      }
  }
  return tail;
}
function buildVuetifyAttrs(valueMeta, model, attrs) {
  if (attrs) {
    attrs = { ...attrs };
    delete attrs["onUpdate:modelValue"];
  }
  if (!valueMeta) {
    return { ...attrs };
  }
  const modelMeta = model ? model.$metadata : null;
  return {
    // If a label is not provided to the component, default to the displayName of the value.
    label: valueMeta == null ? void 0 : valueMeta.displayName,
    hint: valueMeta == null ? void 0 : valueMeta.description,
    // Normalize multi-word name based on what might exist in `attrs`
    // (so that it can be overridden using either casing style).
    // Use kebab style if the camel version isn't detected.
    [attrs && "persistentHint" in attrs ? "persistentHint" : "persistent-hint"]: !!(valueMeta == null ? void 0 : valueMeta.description),
    rules: (
      // We're bound to a ViewModel instance, and the value is a prop on that viewmodel. Ask the ViewModel for the rules.
      model && model instanceof ViewModel && valueMeta.name in modelMeta.props ? model.$getRules(valueMeta.name) : (
        // Grab the rules from the metadata for the bound value
        "rules" in valueMeta && valueMeta.rules ? Object.values(valueMeta.rules) : void 0
      )
    ),
    ...attrs
  };
}
function useMetadataProps(props, transformValueMeta) {
  const metadata = useMetadata();
  const modelMeta = computed(() => {
    return props.model ? props.model.$metadata : null;
  });
  const valueMeta = computed(() => {
    const valueMeta2 = getValueMeta(props.for, modelMeta.value, metadata);
    if (valueMeta2 && "role" in valueMeta2) {
      return (transformValueMeta == null ? void 0 : transformValueMeta(valueMeta2)) ?? valueMeta2;
    }
    return null;
  });
  const valueOwner = computed(() => {
    return getValueMetaAndOwner(props.for, props.model, metadata).valueOwner;
  });
  const attrs = useAttrs();
  const inputBindAttrs = computed(
    () => buildVuetifyAttrs(valueMeta.value, props.model, attrs)
  );
  return { modelMeta, valueMeta, valueOwner, inputBindAttrs };
}
function useCustomInput(props) {
  const form = inject(Symbol.for("vuetify:form"), null);
  const isDisabled = computed(
    () => props.disabled || (form == null ? void 0 : form.isDisabled.value)
  );
  const isReadonly = computed(
    () => props.readonly || (form == null ? void 0 : form.isReadonly.value)
  );
  const isInteractive = computed(() => {
    return !isDisabled.value && !isReadonly.value;
  });
  return { form, isDisabled, isReadonly, isInteractive };
}
const standaloneDateValueMeta = {
  name: "",
  displayName: "",
  type: "date",
  dateKind: "datetime",
  role: "value"
};
const passwordWrapper$1 = defineComponent({
  name: "c-password-display",
  props: {
    element: { type: String, default: "span" },
    value: { type: String, default: "" }
  },
  data() {
    return {
      shown: false
    };
  },
  render() {
    return h(
      this.element,
      mergeProps(this.$attrs, {
        class: this.shown ? "c-password-display c-password-display--shown" : "c-password-display c-password-display--hidden"
      }),
      [
        h("i", {
          class: [!this.shown ? "fa fa-eye" : "fa fa-eye-slash", "pr-1"],
          role: "button",
          pressed: this.shown,
          title: !this.shown ? "Reveal" : "Hide",
          onClick: () => this.shown = !this.shown
        }),
        !this.shown ? "•".repeat(8) : this.value
      ]
    );
  }
});
const _sfc_main$i = /* @__PURE__ */ defineComponent({
  ...{
    name: "c-display"
  },
  __name: "c-display",
  props: {
    model: {},
    for: {},
    element: { default: "span" },
    options: {},
    format: {},
    modelValue: {},
    value: {}
  },
  setup(__props) {
    const props = __props;
    const {
      modelMeta: modelMetaRef,
      valueMeta,
      valueOwner
    } = useMetadataProps(props);
    const attrs = useAttrs();
    const slots = useSlots();
    function render() {
      const model = props.model;
      let valueProp = props.modelValue ?? props.value;
      if (model == null && valueProp == null) {
        return h(props.element);
      }
      const modelMeta = modelMetaRef.value;
      let meta = valueMeta.value;
      if (!meta && modelMeta && "displayProp" in modelMeta) {
        meta = modelMeta.displayProp || null;
      }
      if (!meta && valueProp instanceof Date) {
        meta = standaloneDateValueMeta;
      }
      if (!meta) {
        throw Error(
          "Provided model has no $metadata property, and no specific value was provided via the 'for' component prop to c-display."
        );
      }
      if ("params" in meta) {
        throw Error("Cannot display a method");
      }
      let options = props.options;
      if (props.format) {
        options = { ...options, format: props.format };
      }
      valueProp ?? (valueProp = valueOwner.value[meta.name]);
      let valueString = valueDisplay(valueProp, meta, options);
      if (meta.type === "string" && valueString) {
        switch (meta.subtype) {
          case "password":
            return h(passwordWrapper$1, {
              ...attrs,
              value: valueString
            });
          case "multiline":
            return h(
              props.element,
              {
                ...attrs,
                style: "white-space: pre-wrap"
              },
              valueString || slots
            );
          case "url-image":
            return h("img", {
              ...attrs,
              src: valueString
            });
          case "color":
            return h(
              props.element,
              {
                ...attrs,
                style: "white-space: nowrap"
              },
              [
                h("span", {
                  style: `background-color: ${valueString.replace(
                    /[^A-Fa-f0-9#]/g,
                    ""
                  )};`,
                  class: "c-display--color-swatch"
                }),
                valueString || slots
              ]
            );
          case "url":
          case "email":
          case "tel":
            let href;
            if (meta.subtype == "url") {
              href = valueString;
            } else if (meta.subtype == "email") {
              href = "mailto:" + valueString;
            } else if (meta.subtype == "tel") {
              href = "tel:" + valueString;
            }
            if (href) {
              try {
                new URL(valueString, window.location.origin);
                return h(
                  "a",
                  {
                    ...attrs,
                    href
                  },
                  valueString
                );
              } catch {
              }
            }
        }
      } else if (meta.type === "boolean") {
        if (valueString === "true") {
          valueString = "✓";
        } else if (valueString === "false") {
          valueString = "✗";
        }
      }
      return h(props.element, attrs, valueString || slots);
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(render);
    };
  }
});
const _hoisted_1$8 = { class: "v-field__input" };
const _hoisted_2$8 = { class: "v-select__selection" };
const _hoisted_3$7 = ["autofocus", "disabled", "readonly", "placeholder"];
const _hoisted_4$7 = {
  key: 0,
  class: "grey--text px-4 my-3 font-italic"
};
const _hoisted_5$7 = { key: 0 };
const _hoisted_6$5 = { key: 1 };
const _sfc_main$h = /* @__PURE__ */ defineComponent({
  ...{
    name: "c-select",
    // We manually pass attrs via inputBindAttrs, so disable the default Vue behavior.
    // If we don't do this, some HTML attrs (e.g. tabindex) will incorrectly be placed
    // on the root element rather than on the search field in Vuetify component.
    inheritAttrs: false
  },
  __name: "c-select",
  props: {
    model: {},
    for: {},
    readonly: { type: [Boolean, null] },
    disabled: { type: [Boolean, null] },
    autofocus: { type: Boolean },
    clearable: { type: Boolean, default: void 0 },
    placeholder: {},
    preselectFirst: { type: Boolean },
    preselectSingle: { type: Boolean },
    openOnClear: { type: Boolean, default: true },
    reloadOnOpen: { type: Boolean },
    params: {},
    keyValue: {},
    objectValue: {},
    modelValue: {},
    cache: { type: [Object, Boolean] },
    rules: {},
    create: {}
  },
  emits: ["update:keyValue", "update:objectValue", "update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const mainInputRef = ref();
    const listRef = ref();
    const searchRef = ref();
    const fieldAttrs = computed(
      () => VField.filterProps(
        Object.fromEntries(
          // We have to perform prop name normalization ourselves here
          // because vuetify's filterProps doesn't support the non-camelized names.
          Object.entries(inputBindAttrs.value).map(([k, v]) => [camelize(k), v])
        )
      )
    );
    const { isDisabled, isReadonly, isInteractive } = useCustomInput(props);
    const { inputBindAttrs, modelMeta, valueMeta, valueOwner } = useMetadataProps(
      props,
      (v) => (
        // Use the navigation metadata (if exists) to drive the logic in here,
        // as it will be a better source to pull label, hint, etc. from.
        v.role == "foreignKey" && "navigationProp" in v ? v.navigationProp : v
      )
    );
    const search = ref(null);
    const error = ref([]);
    const focused = ref(false);
    const menuOpen = ref(false);
    const menuOpenForced = ref(false);
    const searchChanged = ref(/* @__PURE__ */ new Date());
    const mainValue = ref("");
    const createItemLoading = ref(false);
    const createItemError = ref("");
    const pendingSelection = ref(0);
    const keyFetchedModel = ref(null);
    const isClearable = computed(() => {
      var _a, _b;
      if (typeof props.clearable == "boolean")
        return props.clearable;
      if (modelKeyProp.value) {
        return !((_a = modelKeyProp.value.rules) == null ? void 0 : _a.required);
      }
      if (valueMeta.value && "rules" in valueMeta.value) {
        return !((_b = valueMeta.value.rules) == null ? void 0 : _b.required);
      }
      if (valueOwner.value) return true;
      return false;
    });
    const modelKeyProp = computed(() => {
      const meta = valueMeta.value;
      if (meta.role == "foreignKey" && "principalType" in meta) {
        return meta;
      }
      if (meta.role == "referenceNavigation" && "foreignKey" in meta) {
        return meta.foreignKey;
      }
      return null;
    });
    const modelObjectProp = computed(
      () => {
        const meta = valueMeta.value;
        if (meta.role == "foreignKey" && "navigationProp" in meta) {
          return meta.navigationProp || null;
        }
        if (meta.role == "referenceNavigation" && "foreignKey" in meta) {
          return meta;
        }
        if (meta.role == "value" && meta.type == "model") {
          return meta;
        }
        return null;
      }
    );
    const primaryBindKind = computed(() => {
      if (!valueMeta.value) {
        throw "c-select requires metadata";
      }
      if (valueMeta.value.role == "foreignKey") {
        return "key";
      }
      if (valueMeta.value.type == "model") {
        if (typeof props.modelValue != "object" && props.modelValue !== void 0) {
          throw "Expected a model object to be bound to modelValue, but received a " + typeof props.modelValue;
        }
        return "model";
      }
      throw "The 'role' of the metadata provided for c-select must be 'foreignKey', or the type must be 'model' ";
    });
    const modelObjectMeta = computed(() => {
      var meta = valueMeta.value;
      if (meta.role == "foreignKey" && "principalType" in meta) {
        return meta.principalType;
      } else if (meta.type == "model") {
        return meta.typeDef;
      } else {
        throw `Value ${meta.name} must be a foreignKey or model type to use c-select.`;
      }
    });
    const internalModelValue = computed(() => {
      if (props.objectValue) {
        return props.objectValue;
      }
      if (valueOwner.value && modelObjectProp.value && valueOwner.value[modelObjectProp.value.name]) {
        return valueOwner.value[modelObjectProp.value.name];
      }
      if (props.modelValue && primaryBindKind.value == "model") {
        return props.modelValue;
      }
      if (internalKeyValue.value) {
        if (keyFetchedModel.value && internalKeyValue.value === keyFetchedModel.value[modelObjectMeta.value.keyProp.name]) {
          return keyFetchedModel.value;
        }
        const item = items.value.filter(
          (i) => internalKeyValue.value === i[modelObjectMeta.value.keyProp.name]
        )[0];
        if (item) {
          keyFetchedModel.value = item;
          return item;
        }
        const singleItem = getCaller.result;
        if (singleItem && internalKeyValue.value === singleItem[modelObjectMeta.value.keyProp.name]) {
          keyFetchedModel.value = singleItem;
          return singleItem;
        }
        if (!listCaller.isLoading && getCaller.args.id != internalKeyValue.value) {
          getCaller.args.id = internalKeyValue.value;
          getCaller.invokeWithArgs();
        }
      }
      return null;
    });
    const internalKeyValue = computed(() => {
      let value;
      if (props.keyValue) {
        value = props.keyValue;
      } else if (valueOwner.value && modelKeyProp.value) {
        value = valueOwner.value[modelKeyProp.value.name];
      } else if (props.modelValue && primaryBindKind.value == "key") {
        value = props.modelValue;
      } else {
        value = null;
      }
      if (value != null) {
        return mapValueToModel(value, modelObjectMeta.value.keyProp);
      }
      return null;
    });
    const effectiveRules = computed(() => {
      var _a, _b;
      if (props.rules) return props.rules;
      if (valueOwner.value instanceof ViewModel && modelKeyProp.value) {
        return ((_a = valueOwner.value.$getRules(modelKeyProp.value)) == null ? void 0 : _a.map((rule) => () => rule(internalKeyValue.value))) ?? [];
      }
      if ((_b = modelKeyProp.value) == null ? void 0 : _b.rules) {
        return Object.values(modelKeyProp.value.rules);
      }
      return [];
    });
    const items = computed(() => {
      return (listCaller == null ? void 0 : listCaller.result) || [];
    });
    const listItems = computed(() => {
      return items.value;
    });
    const createItemLabel = computed(() => {
      if (!props.create || !search.value) return null;
      const result = props.create.getLabel(search.value, items.value);
      if (result) {
        return result;
      }
      return null;
    });
    function onInput(value, dontFocus = false) {
      value = value ?? null;
      if (value == null && !isClearable.value) {
        return;
      }
      error.value = [];
      const key = value ? value[modelObjectMeta.value.keyProp.name] : null;
      keyFetchedModel.value = value;
      if (valueOwner.value) {
        if (modelKeyProp.value) {
          valueOwner.value[modelKeyProp.value.name] = key;
        }
        if (modelObjectProp.value) {
          valueOwner.value[modelObjectProp.value.name] = value;
        }
      }
      emit("update:modelValue", primaryBindKind.value == "key" ? key : value);
      emit("update:objectValue", value);
      emit("update:keyValue", key);
      pendingSelection.value = value ? listItems.value.indexOf(value) : 0;
      if (!dontFocus) {
        if (!value) {
          openMenu();
        } else {
          closeMenu(true);
        }
      }
    }
    function onInputKey(event) {
      if (!isInteractive.value) return;
      switch (event.key.toLowerCase()) {
        case "delete":
        case "backspace":
          if (!menuOpen.value) {
            onInput(null, true);
            event.stopPropagation();
            event.preventDefault();
          }
          return;
        case "esc":
        case "escape":
          event.stopPropagation();
          event.preventDefault();
          closeMenu(true);
          return;
        case " ":
        case "enter":
        case "up":
        case "arrowup":
        case "down":
        case "arrowdown":
        case "spacebar":
        case "space":
          event.stopPropagation();
          event.preventDefault();
          openMenu();
          return;
      }
    }
    function confirmPendingSelection() {
      var item = listItems.value[pendingSelection.value];
      if (!item) return;
      onInput(item);
    }
    async function createItem() {
      if (!createItemLabel.value) return;
      try {
        createItemLoading.value = true;
        const item = await props.create.getItem(
          search.value,
          createItemLabel.value
        );
        if (!item) return;
        onInput(item);
        listCaller();
      } catch (e) {
        createItemError.value = getMessageForError(e);
      } finally {
        createItemLoading.value = false;
      }
    }
    async function openMenu(select) {
      var _a;
      if (!isInteractive.value) return;
      if (select == void 0) {
        select = (/* @__PURE__ */ new Date()).valueOf() - searchChanged.value.valueOf() > 1e3;
      }
      if (menuOpen.value) return;
      menuOpen.value = true;
      if (props.reloadOnOpen) listCaller();
      await nextTick();
      const input = (_a = searchRef.value) == null ? void 0 : _a.$el.querySelector("input");
      const start = performance.now();
      menuOpenForced.value = true;
      while (
        // cap waiting at 100ms
        start + 100 > performance.now() && (!input.offsetParent || input != document.activeElement)
      ) {
        input.focus();
        await new Promise((resolve) => setTimeout(resolve, 1));
      }
      menuOpenForced.value = false;
      if (select) {
        input.select();
      }
    }
    function closeMenu(force = false) {
      var _a;
      if (!menuOpen.value) return;
      if (menuOpenForced.value && !force) return;
      menuOpenForced.value = false;
      menuOpen.value = false;
      (_a = mainInputRef.value) == null ? void 0 : _a.focus();
    }
    const propMeta = valueMeta.value;
    if (!propMeta) {
      throw "c-select requires value metadata. Specify it with the 'for' prop'";
    }
    const getCaller = new ModelApiClient(modelObjectMeta.value).$useSimultaneousRequestCaching().$makeCaller(
      "item",
      function() {
        throw "expected calls to be made with invokeWithArgs";
      },
      () => ({ id: null }),
      (c, args) => c.get(args.id)
    ).setConcurrency("debounce");
    const listCaller = new ModelApiClient(modelObjectMeta.value).$useSimultaneousRequestCaching().$makeCaller("list", (c) => {
      return c.list({
        pageSize: 100,
        ...props.params,
        search: search.value || void 0
      });
    }).onFulfilled(() => {
      pendingSelection.value = 0;
    }).onRejected((state) => {
      error.value = [state.message || "Unknown Error"];
    }).setConcurrency("debounce");
    watch(
      () => JSON.stringify(mapParamsToDto(props.params)),
      () => listCaller()
    );
    watch(
      () => props.cache,
      (c) => {
        getCaller.useResponseCaching(c === true ? {} : c);
        listCaller.useResponseCaching(c === true ? {} : c);
      },
      { immediate: true }
    );
    watch(pendingSelection, async () => {
      var _a, _b;
      await nextTick();
      await nextTick();
      var listDiv = (_a = listRef.value) == null ? void 0 : _a.$el;
      var selectedItem = listDiv == null ? void 0 : listDiv.querySelector(".v-list-item--active");
      (_b = selectedItem == null ? void 0 : selectedItem.scrollIntoView) == null ? void 0 : _b.call(selectedItem, {
        behavior: "auto",
        block: "nearest",
        inline: "nearest"
      });
    });
    watch(search, (newVal, oldVal) => {
      searchChanged.value = /* @__PURE__ */ new Date();
      if (newVal != oldVal) {
        listCaller();
      }
    });
    watch(mainValue, (val) => {
      if (val) {
        nextTick(() => mainValue.value = "");
        searchChanged.value = /* @__PURE__ */ new Date();
        if (!menuOpen.value) {
          search.value = val;
          openMenu(false);
        } else {
          search.value || (search.value = "");
          search.value += val;
        }
      }
    });
    watch(createItemLabel, () => {
      createItemError.value = null;
    });
    listCaller().then(() => {
      if (internalModelValue.value || internalKeyValue.value) {
        return;
      }
      const first = items.value[0];
      if (first && (props.preselectFirst || props.preselectSingle && items.value.length === 1)) {
        onInput(first, true);
      }
    });
    __expose({
      menuOpen,
      search
    });
    return (_ctx, _cache) => {
      const _component_c_display = _sfc_main$i;
      const _component_v_text_field = VTextField;
      const _component_v_fade_transition = VFadeTransition;
      const _component_v_progress_circular = VProgressCircular;
      const _component_v_icon = VIcon;
      const _component_v_list_item_title = VListItemTitle;
      const _component_v_list_item_subtitle = VListItemSubtitle;
      const _component_v_list_item = VListItem;
      const _component_v_list = VList;
      const _component_v_sheet = VSheet;
      const _component_v_menu = VMenu;
      const _component_v_input = VInput;
      return openBlock(), createBlock(_component_v_input, mergeProps({
        class: ["c-select", {
          "c-select--is-menu-active": menuOpen.value
        }],
        "error-messages": error.value,
        focused: focused.value
      }, unref(inputBindAttrs), {
        rules: effectiveRules.value,
        modelValue: internalModelValue.value,
        disabled: unref(isDisabled),
        readonly: unref(isReadonly)
      }), {
        default: withCtx(({ isValid: isValid2 }) => [
          createVNode(unref(VField), mergeProps({
            error: isValid2.value === false,
            "append-inner-icon": "$dropdown"
          }, fieldAttrs.value, {
            clearable: unref(isInteractive) && isClearable.value,
            active: !!internalModelValue.value || focused.value || !!_ctx.placeholder,
            dirty: !!internalModelValue.value,
            focused: focused.value,
            "onClick:clear": _cache[5] || (_cache[5] = withModifiers(($event) => onInput(null, true), ["stop", "prevent"])),
            onKeydown: _cache[6] || (_cache[6] = ($event) => onInputKey($event))
          }), {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_1$8, [
                internalModelValue.value ? renderSlot(_ctx.$slots, "selected-item", {
                  key: 0,
                  item: internalModelValue.value,
                  search: search.value
                }, () => [
                  createElementVNode("span", _hoisted_2$8, [
                    renderSlot(_ctx.$slots, "item", {
                      item: internalModelValue.value,
                      search: search.value
                    }, () => [
                      createVNode(_component_c_display, {
                        class: "v-select__selection-text",
                        model: internalModelValue.value
                      }, null, 8, ["model"])
                    ])
                  ])
                ]) : createCommentVNode("", true),
                withDirectives(createElementVNode("input", {
                  type: "text",
                  ref_key: "mainInputRef",
                  ref: mainInputRef,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => mainValue.value = $event),
                  onMousedown: _cache[1] || (_cache[1] = withModifiers(($event) => (
                    // Intercept direct clicks on the input to short circuit `focused`
                    // and v-menu's activator handler, which introduce some latency before the menu opens
                    // if we allow the menu opening to be handled that way.
                    // Mousedown is needed to prevent `focused` from happening.
                    openMenu()
                  ), ["stop", "prevent"])),
                  onClick: _cache[2] || (_cache[2] = withModifiers(($event) => (
                    // Prevent v-menu's activator handler from running (which is a click handler, not mousedown).
                    openMenu()
                  ), ["stop", "prevent"])),
                  onFocus: _cache[3] || (_cache[3] = ($event) => focused.value = true),
                  onBlur: _cache[4] || (_cache[4] = ($event) => focused.value = false),
                  autofocus: _ctx.autofocus,
                  disabled: unref(isDisabled),
                  readonly: unref(isReadonly),
                  placeholder: internalModelValue.value ? void 0 : _ctx.placeholder
                }, null, 40, _hoisted_3$7), [
                  [vModelText, mainValue.value]
                ])
              ])
            ]),
            _: 2
          }, 1040, ["error", "clearable", "active", "dirty", "focused"]),
          createVNode(_component_v_menu, {
            modelValue: menuOpen.value,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => !$event ? closeMenu() : openMenu()),
            activator: "parent",
            "close-on-content-click": false,
            contentClass: "c-select__menu-content",
            origin: "top",
            location: "top"
          }, {
            default: withCtx(() => [
              createVNode(_component_v_sheet, {
                onKeydownCapture: [
                  _cache[8] || (_cache[8] = withKeys(withModifiers(($event) => pendingSelection.value = Math.min(
                    listItems.value.length - 1,
                    pendingSelection.value + 1
                  ), ["stop", "prevent"]), ["down"])),
                  _cache[9] || (_cache[9] = withKeys(withModifiers(($event) => pendingSelection.value = Math.max(0, pendingSelection.value - 1), ["stop", "prevent"]), ["up"])),
                  withKeys(withModifiers(confirmPendingSelection, ["stop", "prevent"]), ["enter"]),
                  withKeys(withModifiers(confirmPendingSelection, ["stop", "prevent"]), ["tab"])
                ]
              }, {
                default: withCtx(() => [
                  createVNode(_component_v_text_field, {
                    modelValue: search.value,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => search.value = $event),
                    ref_key: "searchRef",
                    ref: searchRef,
                    "hide-details": "auto",
                    "prepend-inner-icon": "fa fa-search",
                    loading: unref(listCaller).isLoading,
                    "error-messages": unref(listCaller).wasSuccessful == false ? unref(listCaller).message ?? void 0 : "",
                    clearable: "",
                    placeholder: "Search",
                    variant: "filled",
                    density: "compact"
                  }, null, 8, ["modelValue", "loading", "error-messages"]),
                  !createItemLabel.value && !listItems.value.length ? (openBlock(), createElementBlock("div", _hoisted_4$7, [
                    createVNode(_component_v_fade_transition, { mode: "out-in" }, {
                      default: withCtx(() => [
                        unref(listCaller).isLoading ? (openBlock(), createElementBlock("span", _hoisted_5$7, "Loading...")) : (openBlock(), createElementBlock("span", _hoisted_6$5, "No results found."))
                      ]),
                      _: 1
                    })
                  ])) : createCommentVNode("", true),
                  createVNode(_component_v_list, {
                    class: "py-0",
                    "max-height": "302",
                    ref_key: "listRef",
                    ref: listRef,
                    density: "compact"
                  }, {
                    default: withCtx(() => [
                      createItemLabel.value ? (openBlock(), createBlock(_component_v_list_item, {
                        key: 0,
                        class: "c-select__create-item",
                        onClick: createItem,
                        loading: createItemLoading.value
                      }, {
                        prepend: withCtx(() => [
                          createItemLoading.value ? (openBlock(), createBlock(_component_v_progress_circular, {
                            key: 0,
                            class: "mr-6",
                            indeterminate: ""
                          })) : (openBlock(), createBlock(_component_v_icon, { key: 1 }, {
                            default: withCtx(() => [
                              createTextVNode("$plus")
                            ]),
                            _: 1
                          }))
                        ]),
                        default: withCtx(() => [
                          createVNode(_component_v_list_item_title, null, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(createItemLabel.value), 1)
                            ]),
                            _: 1
                          }),
                          createItemError.value ? (openBlock(), createBlock(_component_v_list_item_subtitle, {
                            key: 0,
                            class: "text-error font-weight-bold"
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(createItemError.value), 1)
                            ]),
                            _: 1
                          })) : createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["loading"])) : createCommentVNode("", true),
                      (openBlock(true), createElementBlock(Fragment, null, renderList(listItems.value, (item, i) => {
                        return openBlock(), createBlock(_component_v_list_item, {
                          key: item[modelObjectMeta.value.keyProp.name],
                          onClick: ($event) => onInput(item),
                          value: i,
                          active: pendingSelection.value == i
                        }, {
                          default: withCtx(() => [
                            createVNode(_component_v_list_item_title, null, {
                              default: withCtx(() => [
                                renderSlot(_ctx.$slots, "list-item", {
                                  item,
                                  search: search.value
                                }, () => [
                                  renderSlot(_ctx.$slots, "item", {
                                    item,
                                    search: search.value
                                  }, () => [
                                    createVNode(_component_c_display, { model: item }, null, 8, ["model"])
                                  ])
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick", "value", "active"]);
                      }), 128)),
                      // When we do know an actual page count:
                      unref(listCaller).pageCount && unref(listCaller).pageCount > 1 || // When `noCount` is used or counting is disabled on the server:
                      unref(listCaller).pageCount == -1 && unref(listCaller).pageSize && listItems.value.length >= unref(listCaller).pageSize ? (openBlock(), createBlock(_component_v_list_item, {
                        key: 1,
                        class: "text-grey font-italic"
                      }, {
                        default: withCtx(() => [
                          createTextVNode(" Max " + toDisplayString(unref(listCaller).pageSize) + " items retrieved. Refine your search to view more. ", 1)
                        ]),
                        _: 1
                      })) : createCommentVNode("", true)
                    ]),
                    _: 3
                  }, 512)
                ]),
                _: 3
              }, 8, ["onKeydownCapture"])
            ]),
            _: 3
          }, 8, ["modelValue"])
        ]),
        _: 3
      }, 16, ["class", "error-messages", "focused", "rules", "modelValue", "disabled", "readonly"]);
    };
  }
});
const _sfc_main$g = /* @__PURE__ */ defineComponent({
  ...{
    name: "c-select-many-to-many",
    // We manually pass attrs via inputBindAttrs, so disable the default Vue behavior.
    // If we don't do this, some HTML attrs (e.g. tabindex) will incorrectly be placed
    // on the root element rather than on the search field in Vuetify component.
    inheritAttrs: false
  },
  __name: "c-select-many-to-many",
  props: /* @__PURE__ */ mergeModels({
    model: {},
    for: {},
    params: {},
    cache: { type: [Object, Boolean] },
    itemTitle: { type: Function }
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: /* @__PURE__ */ mergeModels(["deleting", "deleted", "adding", "added"], ["update:modelValue"]),
  setup(__props, { emit: __emit }) {
    const modelValue = useModel(__props, "modelValue");
    const props = __props;
    const emit = __emit;
    const { inputBindAttrs, valueMeta } = useMetadataProps(props);
    const search = ref();
    const currentLoaders = ref([]);
    const modelPkValue = computed(() => {
      const model = props.model;
      return model ? model[model.$metadata.keyProp.name] : null;
    });
    const isDisabled = computed(() => {
      if (props.model instanceof ViewModel && props.model.$isAutoSaveEnabled) {
        return modelPkValue.value == null;
      } else {
        return false;
      }
    });
    const items = computed(() => {
      const items2 = listCaller.result || [];
      const manyToMany = manyToManyMeta.value;
      const model = props.model;
      return items2.map(
        (i) => convertToModel(
          {
            [manyToMany.farForeignKey.name]: i[foreignItemKeyPropName.value],
            [manyToMany.farNavigationProp.name]: i,
            [manyToMany.nearForeignKey.name]: modelPkValue.value,
            [manyToMany.nearNavigationProp.name]: model
          },
          collectionMeta.value.itemType.typeDef
        )
      );
    });
    const listItems = computed(() => {
      var _a;
      const added = /* @__PURE__ */ new Set();
      const ret = [];
      const candidateItems = /* @__PURE__ */ new Map();
      for (const item of items.value) {
        const key = itemValue(item);
        candidateItems.set(key, item);
      }
      for (const item of internalValue.value) {
        const key = itemValue(item);
        added.add(key);
        if (!search.value || candidateItems.has(key) || ((_a = itemText(item)) == null ? void 0 : _a.toLowerCase().includes(search.value.toLowerCase()))) {
          ret.push(item);
        }
      }
      for (const item of items.value) {
        const key = itemValue(item);
        if (added.has(key)) continue;
        added.add(key);
        ret.push(item);
      }
      return ret;
    });
    const listParams = computed(() => {
      return {
        pageSize: 100,
        ...props.params,
        search: search.value || void 0
      };
    });
    const isLoading = computed(() => {
      return currentLoaders.value.some((l) => l.isLoading);
    });
    const error = computed(() => {
      for (const loader of currentLoaders.value) {
        if (!loader.wasSuccessful && loader.message) {
          return [loader.message];
        }
      }
      return [];
    });
    const canDelete = computed(() => {
      return (collectionMeta.value.itemType.typeDef.behaviorFlags & BehaviorFlags.Delete) != 0;
    });
    const collectionMeta = computed(() => {
      const meta = valueMeta.value;
      if ((meta == null ? void 0 : meta.type) == "collection" && "manyToMany" in meta) {
        return meta;
      } else {
        throw Error(
          "c-select-many-to-many requires value metadata for a many-to-many collection. Specify it with the 'for' prop'"
        );
      }
    });
    const manyToManyMeta = computed(() => {
      if ("manyToMany" in collectionMeta.value) {
        return collectionMeta.value.manyToMany;
      }
      throw Error(
        "c-select-many-to-many requires value metadata for a many-to-many collection. Specify it with the 'for' prop'"
      );
    });
    const internalValue = computed(() => {
      if (props.model && collectionMeta.value) {
        return props.model[collectionMeta.value.name] || [];
      }
      return modelValue.value || [];
    });
    const foreignItemModelType = computed(() => {
      return manyToManyMeta.value.typeDef;
    });
    const foreignItemKeyPropName = computed(() => {
      return foreignItemModelType.value.keyProp.name;
    });
    function pushLoader(loader) {
      var newArray = currentLoaders.value.filter((l) => l.isLoading);
      loader.message = null;
      newArray.push(loader);
      currentLoaders.value = newArray;
    }
    function itemText(item) {
      if (typeof props.itemTitle === "function") {
        return props.itemTitle(item);
      }
      const foreignItem = foreignItemOf(item);
      if (!foreignItem) {
        const itemFarFk = manyToManyMeta.value.farForeignKey;
        const itemFarNav = manyToManyMeta.value.farNavigationProp;
        console.warn(
          `c-select-many-to-many: Unable to display the name of %o because '${itemFarNav.name}' is not loaded.`,
          item
        );
        return item[itemFarFk.name] || modelDisplay(item);
      }
      return modelDisplay(foreignItem);
    }
    function itemValue(item) {
      if (Array.isArray(item)) {
        return null;
      }
      const foreignItem = foreignItemOf(item);
      if (foreignItem) {
        return foreignItem[foreignItemKeyPropName.value];
      }
      return item[manyToManyMeta.value.farForeignKey.name];
    }
    function onInput(value) {
      const existingItems = new Set(internalValue.value);
      const newItems = new Set(value);
      const items2 = [];
      internalValue.value.forEach((vm) => {
        var _a;
        if (!newItems.has(vm)) {
          if (vm instanceof ViewModel && canDelete.value) {
            if (props.model instanceof ViewModel && props.model.$isAutoSaveEnabled) {
              pushLoader(vm.$delete);
              emit("deleting", vm);
              vm.$delete().then(() => {
                emit("deleted", vm);
                currentLoaders.value = currentLoaders.value.filter(
                  (l) => l != vm.$delete
                );
              }).catch(() => {
                emitInput([...internalValue.value, vm]);
              });
            } else {
              vm._isRemoved = true;
              if (vm.$parent instanceof ViewModel) {
                ((_a = vm.$parent).$removedItems ?? (_a.$removedItems = [])).push(vm);
              }
            }
          }
        } else {
          items2.push(vm);
        }
      });
      newItems.forEach((i) => {
        if (!existingItems.has(i)) {
          let vm = void 0;
          if (props.model instanceof ViewModel) {
            const removedItems = props.model.$removedItems;
            if (removedItems) {
              const manyToMany = manyToManyMeta.value;
              const itemIndex = removedItems.findIndex(
                (x) => x.$metadata == i.$metadata && i[manyToMany.farForeignKey.name] == x[manyToMany.farForeignKey.name]
              );
              if (itemIndex >= 0) {
                const item = removedItems[itemIndex];
                removedItems.splice(itemIndex, 1);
                item._isRemoved = false;
                vm = item;
              }
            }
          }
          if (!vm) {
            vm = ViewModelFactory.get(
              i.$metadata.name,
              i,
              // All of the data of `i`, recursing into any nested objects, IS clean.
              // However, `vm` itself is dirty because it is a brand new object with no PK.
              true
            );
            vm.$isDirty = true;
          }
          items2.push(vm);
          if (props.model instanceof ViewModel && props.model.$isAutoSaveEnabled) {
            pushLoader(vm.$save);
            emit("adding", vm);
            vm.$save().then(() => {
              emit("added", vm);
              currentLoaders.value = currentLoaders.value.filter(
                (l) => l != vm.$save
              );
            }).catch(() => {
              emitInput(internalValue.value.filter((i2) => i2 != vm));
            });
          }
        }
      });
      emitInput(items2);
    }
    function emitInput(items2) {
      if (props.model) {
        return props.model[collectionMeta.value.name] = items2;
      }
      modelValue.value = items2;
    }
    function foreignItemOf(value) {
      return value[manyToManyMeta.value.farNavigationProp.name];
    }
    const listCaller = new ModelApiClient(foreignItemModelType.value).$useSimultaneousRequestCaching().$makeCaller("list", (c) => {
      return c.list(listParams.value);
    }).setConcurrency("debounce");
    watch(
      () => props.cache,
      () => {
        listCaller.useResponseCaching(props.cache === true ? {} : props.cache);
      },
      { immediate: true }
    );
    watch(
      () => JSON.stringify(mapParamsToDto(listParams.value)),
      () => {
        pushLoader(listCaller);
        listCaller();
      }
    );
    manyToManyMeta.value;
    listCaller();
    return (_ctx, _cache) => {
      const _component_v_autocomplete = VAutocomplete;
      return openBlock(), createBlock(_component_v_autocomplete, mergeProps({
        class: "c-select-many-to-many",
        modelValue: internalValue.value,
        "onUpdate:modelValue": onInput,
        multiple: "",
        chips: "",
        "small-chips": "",
        "closable-chips": canDelete.value,
        loading: isLoading.value,
        "error-messages": error.value,
        items: listItems.value,
        search: search.value,
        "onUpdate:search": _cache[0] || (_cache[0] = ($event) => search.value = $event),
        "item-title": itemText,
        "item-value": itemValue,
        "return-object": true,
        disabled: isDisabled.value,
        "no-filter": ""
      }, unref(inputBindAttrs)), null, 16, ["modelValue", "closable-chips", "loading", "error-messages", "items", "search", "disabled"]);
    };
  }
});
const _sfc_main$f = /* @__PURE__ */ defineComponent({
  ...{
    name: "c-select-values",
    // We manually pass attrs via inputBindAttrs, so disable the default Vue behavior.
    // If we don't do this, some HTML attrs (e.g. tabindex) will incorrectly be placed
    // on the root element rather than on the search field in Vuetify component.
    inheritAttrs: false
  },
  __name: "c-select-values",
  props: /* @__PURE__ */ mergeModels({
    model: {},
    for: {}
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props) {
    const props = __props;
    const modelValue = useModel(__props, "modelValue");
    const { inputBindAttrs, valueMeta, valueOwner } = useMetadataProps(props);
    const internalValue = computed(() => {
      if (valueOwner.value && collectionMeta.value) {
        return valueOwner.value[collectionMeta.value.name] || [];
      }
      return modelValue.value || [];
    });
    const collectionMeta = computed(() => {
      const meta = valueMeta.value;
      if (meta && meta.type == "collection" && meta.itemType.type != "model" && meta.itemType.type != "object") {
        return meta;
      } else {
        throw Error(
          "c-select-values requires value metadata for a collection of non-object values. Specify it with the 'for' prop'"
        );
      }
    });
    function onInput(value) {
      if (!Array.isArray(value)) {
        throw new Error("Got non-array from VCombobox's onUpdate:modelValue");
      }
      const items = [];
      for (let i = 0; i < value.length; i++) {
        try {
          items.push(convertValueToModel(value[i], collectionMeta.value.itemType));
        } catch {
        }
      }
      if (valueOwner.value) {
        return valueOwner.value[collectionMeta.value.name] = items;
      }
      modelValue.value = items;
    }
    collectionMeta.value;
    return (_ctx, _cache) => {
      const _component_v_combobox = VCombobox;
      return openBlock(), createBlock(_component_v_combobox, mergeProps({
        class: "c-select-values",
        modelValue: internalValue.value,
        "onUpdate:modelValue": onInput
      }, unref(inputBindAttrs), {
        multiple: "",
        chips: "",
        "closable-chips": "",
        "no-filter": ""
      }), null, 16, ["modelValue"]);
    };
  }
});
const _hoisted_1$7 = { class: "c-time-picker__columns" };
const _hoisted_2$7 = {
  class: "c-time-picker__column",
  "aria-label": "Hour"
};
const _hoisted_3$6 = ["onClick", "disabled"];
const _hoisted_4$6 = {
  class: "c-time-picker__column",
  "aria-label": "Minute"
};
const _hoisted_5$6 = ["onClick", "disabled"];
const _hoisted_6$4 = {
  class: "c-time-picker__column",
  "aria-label": "AM/PM"
};
const _hoisted_7$4 = ["onClick", "disabled"];
const _sfc_main$e = /* @__PURE__ */ defineComponent({
  __name: "c-time-picker",
  props: {
    modelValue: {},
    step: { default: 1 },
    min: {},
    max: {}
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const root = ref();
    const hours = computed(() => {
      return [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].filter(
        (h2) => props.step <= 60 || h2 * 60 % props.step == 0
      );
    });
    const minutes = computed(() => {
      return Array.from(Array(60).keys()).filter((m) => m % props.step == 0);
    });
    const meridiems = [
      format((/* @__PURE__ */ new Date(0)).setHours(0), "a"),
      format((/* @__PURE__ */ new Date(0)).setHours(12), "a")
    ];
    function getDateToModify() {
      return props.modelValue ?? startOfHour(/* @__PURE__ */ new Date());
    }
    function setMinute(minute) {
      const value = getDateToModify();
      emitInput(setMinutes(value, minute));
    }
    function testValid(parts) {
      let value = props.modelValue;
      if (!value || !props.min && !props.max) return true;
      value = set(value, parts);
      if (props.min && value < props.min) {
        return false;
      }
      if (props.max && value > props.max) {
        return false;
      }
      return true;
    }
    function testMeridiamValid(isAM) {
      let value = props.modelValue;
      if (!value || !props.min && !props.max) return true;
      if (props.min && isSameDay(props.min, value) && props.min.getHours() >= 12) {
        return isAM == false;
      }
      if (props.max && isSameDay(props.max, value) && props.max.getHours() < 12) {
        return isAM == true;
      }
      return true;
    }
    function testHourValid(hour) {
      let value = props.modelValue;
      if (!value || !props.min && !props.max) return true;
      hour = hour % 12 + Math.floor(getHours(value) / 12) * 12;
      value = set(value, { hours: hour, minutes: 0, seconds: 0, milliseconds: 0 });
      if (props.min && endOfHour(value) < props.min) {
        return false;
      }
      if (props.max && startOfHour(value) > props.max) {
        return false;
      }
      return true;
    }
    function setHour(hour) {
      const value = getDateToModify();
      hour = hour % 12 + Math.floor(getHours(value) / 12) * 12;
      emitInput(setHours(value, hour));
    }
    function setAM(isAM) {
      const value = getDateToModify();
      const hour = getHours(value) % 12 + (isAM ? 0 : 12);
      emitInput(setHours(value, hour));
    }
    function emitInput(value) {
      emit("update:modelValue", value);
    }
    onMounted(() => {
      watch(
        [root, () => props.modelValue && format(props.modelValue, "h:mm a")],
        async ([root2], [_, oldTime]) => {
          var _a;
          const rootEl = root2 == null ? void 0 : root2.$el;
          if (!rootEl) return;
          await nextTick();
          const noAnimation = (
            // Don't animate when picking a value for the first time.
            !oldTime || // Don't animate for users who don't want animation
            ((_a = window.matchMedia(`(prefers-reduced-motion: reduce)`)) == null ? void 0 : _a.matches) === true
          );
          rootEl.querySelectorAll(".c-time-picker__item-active").forEach((el) => {
            const totalDuration = 350;
            let scrollTarget = 0;
            const start = (/* @__PURE__ */ new Date()).valueOf();
            const parent = el.parentElement;
            if (!parent) return;
            clearInterval(parent._scrollAnimInterval);
            const interval = parent._scrollAnimInterval = setInterval(() => {
              const rect = el.getBoundingClientRect();
              const parentRect = parent.getBoundingClientRect();
              const topInScrollFrame = rect.top - parentRect.top + parent.scrollTop;
              scrollTarget = topInScrollFrame - (parent == null ? void 0 : parent.clientHeight) / 2 + el.clientHeight / 2;
              scrollTarget = Math.min(scrollTarget, parent.scrollHeight);
              scrollTarget = Math.max(scrollTarget, 0);
              parent.scrollTop = noAnimation ? scrollTarget : lerp(
                parent.scrollTop,
                scrollTarget,
                ((/* @__PURE__ */ new Date()).valueOf() - start) / totalDuration
              );
            }, 15);
            setTimeout(() => clearInterval(interval), totalDuration);
          });
        },
        { immediate: true }
      );
    });
    function lerp(a, b, alpha) {
      return a + alpha * (b - a);
    }
    return (_ctx, _cache) => {
      const _component_v_sheet = VSheet;
      return openBlock(), createBlock(_component_v_sheet, {
        class: "c-time-picker",
        ref_key: "root",
        ref: root
      }, {
        default: withCtx(() => [
          createVNode(_component_v_sheet, {
            color: "secondary",
            class: "c-time-picker-header"
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "header", {}, () => [
                createTextVNode(toDisplayString(unref(isValid)(_ctx.modelValue) ? unref(format)(_ctx.modelValue, "h:mm a") : "- : - -"), 1)
              ])
            ]),
            _: 3
          }),
          createElementVNode("div", _hoisted_1$7, [
            createElementVNode("div", _hoisted_2$7, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(hours.value, (i) => {
                return openBlock(), createElementBlock("button", {
                  key: "h-" + i,
                  onClick: ($event) => setHour(i),
                  disabled: !testHourValid(i),
                  tabindex: "0",
                  class: normalizeClass(["c-time-picker__item c-time-picker__item-hour", {
                    "c-time-picker__item-active ": _ctx.modelValue && _ctx.modelValue.getHours() % 12 == i % 12
                  }])
                }, toDisplayString(i), 11, _hoisted_3$6);
              }), 128))
            ]),
            createElementVNode("div", _hoisted_4$6, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(minutes.value, (i) => {
                var _a;
                return openBlock(), createElementBlock("button", {
                  key: "m-" + i,
                  onClick: ($event) => setMinute(i),
                  disabled: !testValid({ minutes: i }),
                  class: normalizeClass(["c-time-picker__item c-time-picker__item-minute", {
                    "c-time-picker__item-active ": ((_a = _ctx.modelValue) == null ? void 0 : _a.getMinutes()) == i
                  }])
                }, toDisplayString(i.toString().padStart(2, "0")), 11, _hoisted_5$6);
              }), 128))
            ]),
            createElementVNode("div", _hoisted_6$4, [
              (openBlock(), createElementBlock(Fragment, null, renderList(meridiems, (item, i) => {
                return createElementVNode("button", {
                  key: item,
                  class: normalizeClass(["c-time-picker__item c-time-picker__item-meridiam", {
                    "c-time-picker__item-active": _ctx.modelValue && i == 0 == _ctx.modelValue.getHours() < 12
                  }]),
                  onClick: ($event) => setAM(i == 0),
                  disabled: !testMeridiamValid(i == 0)
                }, toDisplayString(item), 11, _hoisted_7$4);
              }), 64))
            ])
          ])
        ]),
        _: 3
      }, 512);
    };
  }
});
const _sfc_main$d = /* @__PURE__ */ defineComponent({
  ...{
    name: "c-datetime-picker",
    // We manually pass attrs via inputBindAttrs, so disable the default Vue behavior.
    // If we don't do this, some HTML attrs (e.g. tabindex) will incorrectly be placed
    // on the root element rather than on the search field in the autocomplete.
    inheritAttrs: false
  },
  __name: "c-datetime-picker",
  props: /* @__PURE__ */ mergeModels({
    model: {},
    for: {},
    dateKind: {},
    dateFormat: {},
    readonly: { type: [Boolean, null] },
    disabled: { type: [Boolean, null] },
    native: { type: [Boolean, null] },
    closeOnDatePicked: { type: [Boolean, null], default: null },
    timeZone: {},
    step: {},
    min: {},
    max: {},
    allowedDates: {},
    datePickerProps: {}
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props) {
    const props = __props;
    const modelValue = useModel(__props, "modelValue");
    const { inputBindAttrs, modelMeta, valueMeta, valueOwner } = useMetadataProps(props);
    const focused = ref(false);
    const error = ref([]);
    const menu = ref(false);
    const internalTextValue = ref();
    const { isDisabled, isReadonly, isInteractive } = useCustomInput(props);
    const dateMeta = computed(() => {
      const meta = valueMeta.value;
      if (meta && meta.type == "date") {
        return meta;
      }
      return null;
    });
    const nativeValue = computed(() => {
      return internalValueZoned.value ? format$1(internalValueZoned.value, nativeInternalFormat.value, {
        timeZone: internalTimeZone.value || void 0
      }) : null;
    });
    const displayedValue = computed(() => {
      return internalValueZoned.value ? format$1(internalValueZoned.value, internalFormat.value, {
        timeZone: internalTimeZone.value || void 0
      }) : null;
    });
    const displayedTime = computed(() => {
      return internalValueZoned.value ? format$1(
        internalValueZoned.value,
        "h:mm a" + (internalTimeZone.value ? " z" : ""),
        {
          timeZone: internalTimeZone.value || void 0
        }
      ) : null;
    });
    const internalTimeZone = computed(() => {
      if (props.timeZone) {
        return props.timeZone;
      }
      if (dateMeta.value) {
        if (!dateMeta.value.noOffset) {
          return getDefaultTimeZone() ?? Intl.DateTimeFormat().resolvedOptions().timeZone;
        } else {
          return null;
        }
      }
      return null;
    });
    const internalValue = computed(() => {
      if (valueOwner.value && dateMeta.value) {
        return valueOwner.value[dateMeta.value.name];
      }
      return modelValue.value;
    });
    const internalValueZoned = computed(() => {
      const value = internalValue.value;
      if (!value || !internalTimeZone.value) return value;
      return toZonedTime(value, internalTimeZone.value);
    });
    const internalDateKind = computed(() => {
      if (props.dateKind) return props.dateKind;
      if (dateMeta.value) return dateMeta.value.dateKind;
      return "datetime";
    });
    const nativeInternalFormat = computed(() => {
      switch (internalDateKind.value) {
        case "date":
          return "yyyy-MM-dd";
        case "time":
          return "HH:mm";
        case "datetime":
        default:
          return "yyyy-MM-dd'T'HH:mm";
      }
    });
    const internalFormat = computed(() => {
      if (props.native) {
        return nativeInternalFormat.value;
      }
      if (props.dateFormat) return props.dateFormat;
      switch (internalDateKind.value) {
        case "date":
          return "M/d/yyyy";
        case "time":
          return "h:mm a";
        case "datetime":
        default:
          return "M/d/yyyy h:mm a";
      }
    });
    const effectiveRules = computed(() => {
      var _a;
      return (_a = inputBindAttrs.value.rules) == null ? void 0 : _a.map(
        (ruleFunc) => () => ruleFunc(internalValue.value)
      );
    });
    const showDate = computed(() => {
      return internalDateKind.value == "datetime" || internalDateKind.value == "date";
    });
    const showTime = computed(() => {
      return internalDateKind.value == "datetime" || internalDateKind.value == "time";
    });
    function createDefaultDate() {
      const date = /* @__PURE__ */ new Date();
      if (props.dateKind == "date") {
        const zone = internalTimeZone.value;
        if (!zone) return startOfDay(date);
        return fromZonedTime(startOfDay(toZonedTime(date, zone)), zone);
      } else {
        return startOfHour(date);
      }
    }
    function parseUserInput(val) {
      var value;
      const referenceDate = internalValueZoned.value || createDefaultDate();
      if (!val || !val.trim()) {
        return null;
      } else {
        value = parse(val, internalFormat.value, referenceDate);
        if (!isValid(value)) {
          const separatorRegex = /[\-\\\/\.]/g;
          value = parse(
            val.replace(separatorRegex, "-"),
            internalFormat.value.replace(separatorRegex, "-"),
            referenceDate
          );
        }
        if (!isValid(value) || // A year less than 100(0?) is also invalid.
        // This means that the format for the year was "yyyy",
        // but the user only entered "yy" (or entered 3 digits by accident, hence checking 1000 instead of 100).
        value.getFullYear() <= 1e3) {
          if (props.native) {
            return null;
          }
          value = parseDateUserInput(val, referenceDate, internalDateKind.value) ?? null;
        }
        if (value && internalTimeZone.value) {
          value = fromZonedTime(value, internalTimeZone.value);
        }
      }
      return value;
    }
    function textInputChanged(val, isNative) {
      var _a;
      if (val instanceof Event) {
        val = (_a = val.target) == null ? void 0 : _a.value;
      }
      error.value = [];
      if (val == "" || val == null) {
        internalTextValue.value = "";
        emitInput(null);
        return;
      }
      var value;
      const referenceDate = internalValueZoned.value || createDefaultDate();
      if (isNative) {
        value = parse(val, nativeInternalFormat.value, referenceDate);
      } else {
        internalTextValue.value = val;
        value = parseUserInput(val);
      }
      if (isValid(value)) emitInput(value);
    }
    function timeChanged(input) {
      error.value = [];
      var value = internalValueZoned.value || createDefaultDate();
      value = setHours(value, input.getHours());
      value = setMinutes(value, input.getMinutes());
      if (internalTimeZone.value) {
        value = fromZonedTime(value, internalTimeZone.value);
      }
      emitInput(value);
    }
    function dateChanged(input) {
      if (!input || !(input instanceof Date)) return;
      error.value = [];
      var value = internalValueZoned.value || createDefaultDate();
      value = setDate(value, 1);
      value = setYear(value, input.getFullYear());
      value = setMonth(value, input.getMonth());
      value = setDate(value, input.getDate());
      if (internalTimeZone.value) {
        value = fromZonedTime(value, internalTimeZone.value);
      }
      emitInput(value);
      if (props.closeOnDatePicked == null ? internalDateKind.value == "date" : props.closeOnDatePicked) {
        close();
      }
    }
    function emitInput(value) {
      if (value) {
        if (props.allowedDates) {
          if (Array.isArray(props.allowedDates) && !props.allowedDates.includes(startOfDay(value))) {
            error.value.push("The selected date is not allowed.");
            return;
          } else if (typeof props.allowedDates == "function" && !props.allowedDates(value)) {
            error.value.push("The selected date is not allowed.");
            return;
          }
        }
        if (props.min && value.valueOf() < props.min.valueOf()) {
          value = props.min;
        }
        if (props.max && value.valueOf() > props.max.valueOf()) {
          value = props.max;
        }
        if (props.step) {
          const stepMs = props.step * 60 * 1e3;
          let newTime = Math.round(value.valueOf() / stepMs) * stepMs;
          if (props.max && newTime > props.max.valueOf()) newTime -= stepMs;
          else if (props.min && newTime < props.min.valueOf()) newTime += stepMs;
          value = new Date(newTime);
        }
      }
      if (valueOwner.value && dateMeta.value) {
        valueOwner.value[dateMeta.value.name] = value;
      }
      if (modelValue.value != value) {
        modelValue.value = value;
      }
    }
    function close() {
      menu.value = false;
    }
    watch(focused, (focused2) => {
      if (!focused2) {
        if (internalTextValue.value && !isValid(parseUserInput(internalTextValue.value))) {
          error.value = [
            'Invalid value. Try formatting like "' + format$1(/* @__PURE__ */ new Date(), internalFormat.value) + '"'
          ];
        } else {
          internalTextValue.value = void 0;
        }
      }
    });
    return (_ctx, _cache) => {
      const _component_v_text_field = VTextField;
      const _component_v_fab = VFab;
      const _component_v_date_picker = VDatePicker;
      const _component_v_divider = VDivider;
      const _component_v_card = VCard;
      const _component_v_menu = VMenu;
      return _ctx.native ? (openBlock(), createBlock(_component_v_text_field, mergeProps({
        key: 0,
        class: "c-datetime-picker",
        type: internalDateKind.value == "time" ? "time" : internalDateKind.value == "date" ? "date" : "datetime-local",
        modelValue: nativeValue.value
      }, unref(inputBindAttrs), {
        rules: effectiveRules.value,
        "error-messages": error.value,
        readonly: unref(isReadonly),
        disabled: unref(isDisabled),
        autocomplete: "off",
        focused: focused.value,
        "onUpdate:focused": _cache[0] || (_cache[0] = ($event) => focused.value = $event),
        onChange: _cache[1] || (_cache[1] = ($event) => textInputChanged($event, true))
      }), null, 16, ["type", "modelValue", "rules", "error-messages", "readonly", "disabled", "focused"])) : (openBlock(), createBlock(_component_v_text_field, mergeProps({
        key: 1,
        class: "c-datetime-picker"
      }, unref(inputBindAttrs), {
        rules: effectiveRules.value,
        modelValue: internalTextValue.value == null ? displayedValue.value : internalTextValue.value,
        "error-messages": error.value,
        readonly: unref(isReadonly),
        disabled: unref(isDisabled),
        autocomplete: "off",
        placeholder: internalFormat.value,
        focused: focused.value,
        "onUpdate:focused": _cache[4] || (_cache[4] = ($event) => focused.value = $event),
        onKeydown: [
          _cache[5] || (_cache[5] = withKeys(($event) => focused.value = false, ["enter"])),
          _cache[6] || (_cache[6] = withKeys(($event) => focused.value = false, ["escape"]))
        ],
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => textInputChanged($event, false)),
        onClick: _cache[8] || (_cache[8] = ($event) => menu.value = !menu.value),
        "append-inner-icon": internalDateKind.value == "time" ? "fa fa-clock cursor-pointer" : "fa fa-calendar-alt cursor-pointer"
      }), {
        default: withCtx(() => [
          unref(isInteractive) ? (openBlock(), createBlock(_component_v_menu, {
            key: 0,
            modelValue: menu.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => menu.value = $event),
            activator: "parent",
            "content-class": "c-datetime-picker__menu",
            "close-on-content-click": false,
            "open-on-click": false,
            "min-width": "1px"
          }, {
            default: withCtx(() => [
              createVNode(_component_v_fab, {
                app: "",
                location: "bottom right",
                color: "secondary",
                size: "x-small",
                icon: "$complete",
                onClick: _cache[2] || (_cache[2] = ($event) => menu.value = false),
                title: _ctx.$vuetify.locale.t("$vuetify.close")
              }, null, 8, ["title"]),
              createVNode(_component_v_card, { class: "d-flex" }, {
                default: withCtx(() => [
                  showDate.value ? (openBlock(), createBlock(_component_v_date_picker, mergeProps({
                    key: 0,
                    color: "secondary",
                    modelValue: internalValueZoned.value,
                    "onUpdate:modelValue": dateChanged,
                    density: "comfortable",
                    scrollable: "",
                    rounded: false,
                    allowedDates: _ctx.allowedDates,
                    min: _ctx.min ? unref(startOfDay)(_ctx.min) : void 0,
                    max: _ctx.max ? unref(endOfDay)(_ctx.max) : void 0
                  }, _ctx.datePickerProps), null, 16, ["modelValue", "allowedDates", "min", "max"])) : createCommentVNode("", true),
                  createVNode(_component_v_divider, { vertical: "" }),
                  showTime.value ? (openBlock(), createBlock(_sfc_main$e, {
                    key: 1,
                    "model-value": internalValueZoned.value,
                    "onUpdate:modelValue": timeChanged,
                    step: _ctx.step ?? void 0,
                    min: _ctx.min,
                    max: _ctx.max
                  }, {
                    header: withCtx(() => [
                      createTextVNode(toDisplayString(displayedTime.value || " "), 1)
                    ]),
                    _: 1
                  }, 8, ["model-value", "step", "min", "max"])) : createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])) : createCommentVNode("", true)
        ]),
        _: 1
      }, 16, ["rules", "modelValue", "error-messages", "readonly", "disabled", "placeholder", "focused", "append-inner-icon"]));
    };
  }
});
const primitiveTypes = ["string", "number", "date", "enum", "boolean"];
const passwordWrapper = defineComponent({
  name: "c-password-input",
  data() {
    return {
      shown: false
    };
  },
  render() {
    const data = {
      ...this.$attrs
    };
    data["append-inner-icon"] ?? (data["append-inner-icon"] = !this.shown ? "fa fa-eye" : "fa fa-eye-slash");
    data.type = this.shown ? "text" : "password";
    addHandler(data, "click:appendInner", () => this.shown = !this.shown);
    return h(VTextField, data, this.$slots);
  }
});
function addHandler(data, eventName, handler) {
  eventName = toHandlerKey(eventName);
  const oldValue = data[eventName];
  if (oldValue == null) {
    data[eventName] = handler;
  } else if (typeof oldValue == "function") {
    data[eventName] = [oldValue, handler];
  } else {
    oldValue.push(handler);
  }
}
const _sfc_main$c = /* @__PURE__ */ defineComponent({
  ...{
    name: "c-input",
    inject: {
      "c-input-props": { default: {} }
    }
  },
  __name: "c-input",
  props: {
    model: {},
    for: {},
    rules: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const { valueMeta: valueMetaRef, valueOwner: valueOwnerRef } = useMetadataProps(props);
    const emit = __emit;
    const attrs = useAttrs();
    const slots = useSlots();
    function render() {
      const valueMeta = valueMetaRef.value;
      const valueOwner = valueOwnerRef.value;
      if (!valueMeta || !("role" in valueMeta)) {
        throw Error(
          "c-input requires value metadata. Specify it with the 'for' prop'"
        );
      }
      let data = {
        ...attrs,
        // Includes any non-props, as well as event handlers.
        rules: props.rules ?? attrs.rules,
        modelValue: valueOwner ? valueOwner[valueMeta.name] : primitiveTypes.includes(valueMeta.type) ? mapValueToModel(props.modelValue, valueMeta) : props.modelValue
      };
      if (data.rules === void 0) delete data.rules;
      switch (valueMeta.type) {
        case "date":
          data.model = props.model;
          data.for = props.for;
          addHandler(
            data,
            "update:modelValue",
            (v) => emit("update:modelValue", v)
          );
          return h(_sfc_main$d, data, slots);
        case "model":
          data.model = props.model;
          data.for = props.for;
          addHandler(
            data,
            "update:modelValue",
            (v) => emit("update:modelValue", v)
          );
          return h(_sfc_main$h, data, slots);
        case "collection":
          data.model = props.model;
          data.for = props.for;
          if ("manyToMany" in valueMeta) {
            addHandler(
              data,
              "update:modelValue",
              (v) => emit("update:modelValue", v)
            );
            return h(_sfc_main$g, data, slots);
          } else if (valueMeta.itemType.type != "model" && valueMeta.itemType.type != "object" && valueMeta.itemType.type != "enum" && valueMeta.itemType.type != "file") {
            addHandler(
              data,
              "update:modelValue",
              (v) => emit("update:modelValue", v)
            );
            return h(_sfc_main$f, data, slots);
          } else ;
      }
      data = {
        ...buildVuetifyAttrs(valueMeta, props.model, data),
        ...data
      };
      const onInput = (value) => {
        const parsed = parseValue(value, valueMeta);
        if (valueOwner && valueMeta) {
          valueOwner[valueMeta.name] = parsed;
        }
        emit("update:modelValue", parsed);
      };
      const { default: defaultSlot, ...vuetifySlots } = slots;
      switch (valueMeta.type) {
        case "string":
        case "number":
          if ("createOnly" in valueMeta && valueMeta.createOnly) {
            addHandler(data, "change", (valueOrEvent) => {
              if (valueOrEvent instanceof Event) {
                if (valueOrEvent.target instanceof HTMLInputElement || valueOrEvent.target instanceof HTMLTextAreaElement) {
                  onInput(valueOrEvent.target.value);
                }
              } else {
                onInput(valueOrEvent);
              }
            });
          } else {
            addHandler(data, "update:modelValue", onInput);
          }
          if (valueMeta.type == "number") {
            data.type = "number";
            return h(VTextField, data, vuetifySlots);
          }
          if (("textarea" in data || valueMeta.subtype == "multiline") && data.textarea !== false) {
            return h(VTextarea, data, vuetifySlots);
          }
          if (!data.type && valueMeta.subtype) {
            switch (valueMeta.subtype) {
              case "email":
              case "tel":
                data.type = valueMeta.subtype;
                break;
              case "color":
                addHandler(data, "mouseup", function(e) {
                  var _a;
                  const t = e.currentTarget;
                  (t == null ? void 0 : t.matches(".v-input__slot")) && ((_a = t.querySelector("input")) == null ? void 0 : _a.click());
                });
                data.type = valueMeta.subtype;
                break;
              case "url":
              case "url-image":
                data.type = "url";
                break;
              case "password":
                return h(passwordWrapper, data, vuetifySlots);
            }
          }
          return h(VTextField, data, vuetifySlots);
        case "boolean":
          addHandler(data, "update:modelValue", onInput);
          if ("checkbox" in data && data.checkbox !== false) {
            return h(VCheckbox, data, vuetifySlots);
          }
          return h(VSwitch, data, vuetifySlots);
        case "enum":
          addHandler(data, "update:modelValue", onInput);
          data.items = valueMeta.typeDef.values;
          data["item-title"] = "displayName";
          data["item-value"] = "value";
          data["item-props"] = (item) => ({ subtitle: item.description });
          return h(VSelect, data, vuetifySlots);
        case "file":
          const updateHandler = (value) => onInput(Array.isArray(value) ? value[0] : value);
          addHandler(data, "update:modelValue", updateHandler);
          return h(VFileInput, data, vuetifySlots);
        case "collection":
          if (valueMeta.itemType.type == "file") {
            data.multiple = "";
            data.modelValue ?? (data.modelValue = []);
            addHandler(data, "update:modelValue", onInput);
            return h(VFileInput, data, vuetifySlots);
          } else if (valueMeta.itemType.type == "enum") {
            data.items = valueMeta.itemType.typeDef.values;
            data.multiple = true;
            data["chips"] = true;
            data["closable-chips"] = true;
            data["item-title"] = "displayName";
            data["item-value"] = "value";
            data["item-props"] = (item) => ({ subtitle: item.description });
            addHandler(data, "update:modelValue", onInput);
            return h(VAutocomplete, data, vuetifySlots);
          }
      }
      if (defaultSlot) {
        return h("div", {}, { default: defaultSlot });
      }
      return h(
        "div",
        {
          staticClass: "input-group input-group--dirty input-group--text-field"
        },
        [
          h("label", data.label),
          h("p", [
            h(_sfc_main$i, {
              staticClass: "subtitle-1",
              props: {
                value: data.value,
                model: props.model,
                for: props.for
              }
            })
          ])
        ]
      );
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(render);
    };
  }
});
const _hoisted_1$6 = /* @__PURE__ */ createElementVNode("span", { class: "hidden-sm-and-down" }, "Reload", -1);
const _hoisted_2$6 = { class: "c-admin-table-toolbar--range hidden-sm-and-down" };
const _hoisted_3$5 = { class: "c-audit-logs--filters" };
const _hoisted_4$5 = /* @__PURE__ */ createElementVNode("thead", null, [
  /* @__PURE__ */ createElementVNode("tr", null, [
    /* @__PURE__ */ createElementVNode("th", { class: "c-audit-logs--column-user-date" }, "By/Date"),
    /* @__PURE__ */ createElementVNode("th", { class: "c-audit-logs--column-entity" }, "Entity"),
    /* @__PURE__ */ createElementVNode("th", { class: "c-audit-logs--column-details" }, "Details"),
    /* @__PURE__ */ createElementVNode("th", { class: "c-audit-logs--column-properties" }, "Properties")
  ])
], -1);
const _hoisted_5$5 = { class: "c-audit-logs--column-user-date" };
const _hoisted_6$3 = ["textContent"];
const _hoisted_7$3 = { class: "c-audit-logs--column-entity" };
const _hoisted_8$2 = { title: "Entity Type" };
const _hoisted_9$2 = {
  style: { "white-space": "break-spaces", "display": "inline-block", "vertical-align": "top" },
  title: "Entity Key"
};
const _hoisted_10$2 = ["textContent"];
const _hoisted_11$1 = { class: "c-audit-logs--column-details c-audit-logs--row-detail" };
const _hoisted_12 = { class: "prop-state" };
const _hoisted_13 = /* @__PURE__ */ createElementVNode("td", null, "Change:", -1);
const _hoisted_14 = { class: "c-audit-logs--column-properties c-audit-logs--row-properties" };
const _hoisted_15 = /* @__PURE__ */ createElementVNode("thead", null, [
  /* @__PURE__ */ createElementVNode("tr", null, [
    /* @__PURE__ */ createElementVNode("th", { class: "c-audit-logs--property-name" }, "Property"),
    /* @__PURE__ */ createElementVNode("th", null, "Old"),
    /* @__PURE__ */ createElementVNode("th", null, "New")
  ])
], -1);
const _hoisted_16 = { class: "c-audit-logs--property-name" };
const _hoisted_17 = { class: "c-audit-logs--property-value c-audit-logs--property-old" };
const _hoisted_18 = {
  key: 0,
  class: "c-audit-logs--property-value-desc text-grey"
};
const _hoisted_19 = { class: "c-audit-logs--property-value c-audit-logs--property-old" };
const _hoisted_20 = {
  key: 0,
  class: "c-audit-logs--property-value-desc text-grey"
};
const _sfc_main$b = /* @__PURE__ */ defineComponent({
  __name: "c-admin-audit-log-page",
  props: {
    type: {},
    color: { default: "primary" },
    list: {}
  },
  setup(__props, { expose: __expose }) {
    const props = __props;
    let listVm;
    if (props.list) {
      listVm = props.list;
    } else {
      if (!props.type) {
        throw Error(
          "c-admin-audit-log-page: If prop `list` is not provided, `type` is required."
        );
      } else if (!ListViewModel.typeLookup[props.type]) {
        throw Error(
          `No model named ${props.type} is registered to ListViewModel.typeLookup`
        );
      }
      listVm = new ListViewModel.typeLookup[props.type]();
      listVm.$load.setConcurrency("cancel");
      listVm.$modelOnlyMode = true;
    }
    const items = computed(
      () => listVm.$modelOnlyMode ? toRaw(listVm.$modelItems) : listVm.$items
    );
    const userPropMeta = computed(() => {
      return Object.values(listVm.$metadata.props).filter(
        (p) => p.role == "referenceNavigation"
      ).filter(
        (p) => ["user", "createdby", "changedby"].some(
          (needle) => p.name.toLowerCase().includes(needle)
        )
      )[0];
    });
    const otherProps = computed(() => {
      return Object.values(listVm.$metadata.props).filter(
        (p) => ((p.hidden || 0) & HiddenAreas.List) != HiddenAreas.List && p != userPropMeta.value && ![
          "id",
          "type",
          "keyValue",
          "date",
          "state",
          "properties",
          "description"
        ].includes(p.name) && (p.role !== "foreignKey" || !p.navigationProp)
      );
    });
    function timeDiff(current, older) {
      if (!older) return "";
      let ms = differenceInMilliseconds(current.date, older.date);
      const positive = ms >= 0;
      ms = Math.abs(ms);
      var totalSec = ms / 1e3;
      var hours = Math.floor(totalSec / 3600);
      var minutes = Math.floor((totalSec - hours * 3600) / 60);
      var seconds = totalSec - hours * 3600 - minutes * 60;
      return (positive ? "+" : "-") + (hours > 0 ? hours + "h " : "") + (hours > 0 || minutes > 0 ? minutes + "m " : "") + seconds.toFixed(2) + "s";
    }
    function timeDiffClass(current, older) {
      if (!older) return "";
      const diff = current.date.valueOf() - ((older == null ? void 0 : older.date) ?? 0).valueOf();
      return diff == 0 ? "grey--text" : diff > 0 ? "text-success" : "text-error";
    }
    const filter = listVm.$params.filter = reactive({
      type: "",
      keyValue: "",
      state: ""
    });
    useBindToQueryString(filter, "type");
    useBindToQueryString(filter, "keyValue");
    useBindToQueryString(filter, "state");
    useBindToQueryString(listVm.$params, "page", { parse: parseInt });
    useBindToQueryString(listVm.$params, "pageSize", { parse: parseInt });
    if (userPropMeta.value) {
      const fkName = userPropMeta.value.foreignKey.name;
      filter[fkName] = "";
      useBindToQueryString(filter, fkName, { queryKey: "user" });
    }
    listVm.$load();
    listVm.$useAutoLoad({ wait: 100 });
    __expose({
      /** Support for common convention of exposing 'pageTitle' from router-view hosted components. */
      pageTitle: "Audit Logs"
    });
    return (_ctx, _cache) => {
      const _component_v_toolbar_title = VToolbarTitle;
      const _component_v_divider = VDivider;
      const _component_v_icon = VIcon;
      const _component_v_btn = VBtn;
      const _component_v_spacer = VSpacer;
      const _component_c_list_range_display = __unplugin_components_5;
      const _component_c_list_page = _sfc_main$m;
      const _component_v_combobox = VCombobox;
      const _component_v_text_field = VTextField;
      const _component_c_input = _sfc_main$c;
      const _component_c_select = _sfc_main$h;
      const _component_v_defaults_provider = VDefaultsProvider;
      const _component_c_list_page_size = __unplugin_components_9;
      const _component_v_toolbar = VToolbar;
      const _component_c_display = _sfc_main$i;
      const _component_v_table = VTable;
      const _component_c_list_pagination = __unplugin_components_3;
      const _component_c_loader_status = _sfc_main$n;
      const _component_v_card_text = VCardText;
      const _component_v_card = VCard;
      const _component_v_container = VContainer;
      return openBlock(), createBlock(_component_v_container, {
        fluid: "",
        class: "c-admin-audit-log-page"
      }, {
        default: withCtx(() => [
          createVNode(_component_v_card, { class: "c-admin-audit-log-page" }, {
            default: withCtx(() => [
              createVNode(_component_v_toolbar, {
                extended: "",
                class: "c-admin-table-toolbar",
                density: "comfortable",
                color: _ctx.color
              }, {
                extension: withCtx(() => [
                  createVNode(_component_v_defaults_provider, { defaults: {
                    global: {
                      hideDetails: "auto",
                      density: "compact",
                      variant: "outlined",
                      clearable: true,
                      persistentClear: true
                    }
                  } }, {
                    default: withCtx(() => [
                      createElementVNode("div", _hoisted_3$5, [
                        createVNode(_component_v_combobox, {
                          modelValue: unref(filter).type,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => unref(filter).type = $event),
                          items: Object.values(_ctx.$coalesce.metadata.types).filter((t) => "controllerRoute" in t).map((t) => t.name),
                          label: "Entity Type",
                          style: { "width": "150px" },
                          clearable: !!unref(filter).type,
                          "list-props": { density: "compact" },
                          "onClick:clear": _cache[2] || (_cache[2] = ($event) => _ctx.$nextTick(() => delete unref(filter).type))
                        }, null, 8, ["modelValue", "items", "clearable"]),
                        createVNode(_component_v_text_field, {
                          modelValue: unref(filter).keyValue,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => unref(filter).keyValue = $event),
                          label: "Key Value",
                          style: { "width": "150px" },
                          "onClick:clear": _cache[4] || (_cache[4] = ($event) => _ctx.$nextTick(() => unref(filter).keyValue = ""))
                        }, null, 8, ["modelValue"]),
                        createVNode(_component_c_input, {
                          modelValue: unref(filter).state,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => unref(filter).state = $event),
                          for: unref(listVm).$metadata.props.state,
                          "onClick:clear": _cache[6] || (_cache[6] = ($event) => _ctx.$nextTick(() => unref(filter).state = "")),
                          style: { "min-width": "210px", "max-width": "210px" }
                        }, null, 8, ["modelValue", "for"]),
                        userPropMeta.value ? (openBlock(), createBlock(_component_c_select, {
                          key: 0,
                          for: userPropMeta.value,
                          "key-value": unref(filter)[userPropMeta.value.foreignKey.name],
                          "onUpdate:keyValue": _cache[7] || (_cache[7] = ($event) => unref(filter)[userPropMeta.value.foreignKey.name] = $event),
                          clearable: "",
                          style: { "width": "240px" },
                          "onClick:clear": _cache[8] || (_cache[8] = ($event) => _ctx.$nextTick(() => unref(filter)[userPropMeta.value.foreignKey.name] = ""))
                        }, null, 8, ["for", "key-value"])) : createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }),
                  createVNode(_component_v_spacer),
                  createVNode(_component_c_list_page_size, { list: unref(listVm) }, null, 8, ["list"])
                ]),
                default: withCtx(() => [
                  createVNode(_component_v_toolbar_title, { class: "c-admin-table-toolbar--model-name hidden-xs-only" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(listVm).$metadata.displayName), 1)
                    ]),
                    _: 1
                  }),
                  createVNode(_component_v_divider, {
                    class: "hidden-xs-only mx-4",
                    vertical: ""
                  }),
                  createVNode(_component_v_btn, {
                    class: "c-admin-table-toolbar--button-reload",
                    variant: "text",
                    onClick: _cache[0] || (_cache[0] = ($event) => unref(listVm).$load())
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_v_icon, { start: "" }, {
                        default: withCtx(() => [
                          createTextVNode("$loading")
                        ]),
                        _: 1
                      }),
                      _hoisted_1$6
                    ]),
                    _: 1
                  }),
                  createVNode(_component_v_spacer),
                  createElementVNode("span", _hoisted_2$6, [
                    createTextVNode(" Showing "),
                    createVNode(_component_c_list_range_display, { list: unref(listVm) }, null, 8, ["list"])
                  ]),
                  createVNode(_component_v_spacer),
                  createVNode(_component_c_list_page, {
                    class: "c-admin-table-toolbar--page",
                    list: unref(listVm)
                  }, null, 8, ["list"])
                ]),
                _: 1
              }, 8, ["color"]),
              createVNode(_component_v_card_text, null, {
                default: withCtx(() => [
                  createVNode(_component_c_loader_status, {
                    loaders: {
                      "no-initial-content no-error-content": [unref(listVm).$load]
                    }
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_v_table, { class: "c-audit-logs--table" }, {
                        default: withCtx(() => [
                          _hoisted_4$5,
                          createElementVNode("tbody", null, [
                            (openBlock(true), createElementBlock(Fragment, null, renderList(items.value, (auditLog, index) => {
                              return openBlock(), createElementBlock("tr", {
                                key: auditLog.id
                              }, [
                                createElementVNode("td", _hoisted_5$5, [
                                  userPropMeta.value ? (openBlock(), createBlock(_component_c_display, {
                                    key: 0,
                                    model: auditLog,
                                    element: "div",
                                    for: userPropMeta.value.name,
                                    class: "text-no-wrap"
                                  }, null, 8, ["model", "for"])) : createCommentVNode("", true),
                                  createVNode(_component_c_display, {
                                    model: auditLog,
                                    element: "div",
                                    for: "date",
                                    class: "text-no-wrap text-caption d-block",
                                    format: "M/dd/yy h:mm:ss a z",
                                    title: [
                                      unref(propDisplay)(auditLog, "date", {
                                        format: {
                                          format: "yyyy-MM-dd HH:mm:ss.SSS z"
                                        }
                                      }),
                                      unref(propDisplay)(auditLog, "date", {
                                        format: {
                                          format: "yyyy-MM-dd HH:mm:ss.SSS z",
                                          timeZone: "UTC"
                                        }
                                      }),
                                      (auditLog.date.valueOf() / 1e3).toFixed(3) + " (Unix Seconds)"
                                    ].join("\n")
                                  }, null, 8, ["model", "title"]),
                                  createElementVNode("pre", {
                                    class: normalizeClass(timeDiffClass(auditLog, items.value[index + 1])),
                                    textContent: toDisplayString(timeDiff(auditLog, items.value[index + 1])),
                                    title: "Time delta from the preceding row"
                                  }, null, 10, _hoisted_6$3)
                                ]),
                                createElementVNode("td", _hoisted_7$3, [
                                  createElementVNode("pre", _hoisted_8$2, toDisplayString(auditLog.type), 1),
                                  createElementVNode("pre", _hoisted_9$2, toDisplayString(auditLog.keyValue), 1),
                                  auditLog.description ? (openBlock(), createElementBlock("div", {
                                    key: 0,
                                    textContent: toDisplayString(auditLog.description),
                                    class: "c-audit-logs--entry-desc text-grey"
                                  }, null, 8, _hoisted_10$2)) : createCommentVNode("", true)
                                ]),
                                createElementVNode("td", _hoisted_11$1, [
                                  renderSlot(_ctx.$slots, "row-detail", { item: auditLog }, () => [
                                    createElementVNode("table", null, [
                                      createElementVNode("tbody", null, [
                                        createElementVNode("tr", _hoisted_12, [
                                          _hoisted_13,
                                          createElementVNode("td", null, [
                                            createVNode(_component_c_display, {
                                              model: auditLog,
                                              for: "state"
                                            }, null, 8, ["model"])
                                          ])
                                        ]),
                                        (openBlock(true), createElementBlock(Fragment, null, renderList(otherProps.value, (propMeta) => {
                                          return openBlock(), createElementBlock("tr", {
                                            key: auditLog.id + "-prop-" + propMeta.name,
                                            class: normalizeClass("prop-" + propMeta.name)
                                          }, [
                                            createElementVNode("td", null, toDisplayString(propMeta.displayName) + ":", 1),
                                            createElementVNode("td", null, [
                                              createVNode(_component_c_display, {
                                                model: auditLog,
                                                for: propMeta,
                                                class: "text-grey"
                                              }, null, 8, ["model", "for"])
                                            ])
                                          ], 2);
                                        }), 128)),
                                        renderSlot(_ctx.$slots, "row-detail-append", { item: auditLog })
                                      ])
                                    ])
                                  ])
                                ]),
                                createElementVNode("td", _hoisted_14, [
                                  createElementVNode("table", null, [
                                    _hoisted_15,
                                    createElementVNode("tbody", null, [
                                      (openBlock(true), createElementBlock(Fragment, null, renderList(auditLog.properties, (prop) => {
                                        return openBlock(), createElementBlock("tr", {
                                          key: prop.id
                                        }, [
                                          createElementVNode("td", _hoisted_16, toDisplayString(prop.propertyName), 1),
                                          createElementVNode("td", _hoisted_17, [
                                            createTextVNode(toDisplayString(prop.oldValue) + " ", 1),
                                            prop.oldValueDescription ? (openBlock(), createElementBlock("span", _hoisted_18, " (" + toDisplayString(prop.oldValueDescription) + ") ", 1)) : createCommentVNode("", true)
                                          ]),
                                          createElementVNode("td", _hoisted_19, [
                                            createTextVNode(toDisplayString(prop.newValue) + " ", 1),
                                            prop.newValueDescription ? (openBlock(), createElementBlock("span", _hoisted_20, " (" + toDisplayString(prop.newValueDescription) + ") ", 1)) : createCommentVNode("", true)
                                          ])
                                        ]);
                                      }), 128))
                                    ])
                                  ])
                                ])
                              ]);
                            }), 128))
                          ])
                        ]),
                        _: 3
                      }),
                      createVNode(_component_v_divider),
                      createVNode(_component_c_list_pagination, {
                        list: unref(listVm),
                        class: "mt-4"
                      }, null, 8, ["list"])
                    ]),
                    _: 3
                  }, 8, ["loaders"])
                ]),
                _: 3
              })
            ]),
            _: 3
          })
        ]),
        _: 3
      });
    };
  }
});
const _sfc_main$a = /* @__PURE__ */ defineComponent({
  ...{
    name: "c-admin-display"
  },
  __name: "c-admin-display",
  props: {
    model: {},
    for: {},
    element: { default: "span" },
    options: {},
    format: {},
    modelValue: {},
    value: {}
  },
  setup(__props) {
    const props = __props;
    const router = useRouter();
    const { modelMeta: modelMetaRef, valueMeta } = useMetadataProps(props);
    function render() {
      const { model } = props;
      if (model == null) {
        return h("span");
      }
      const modelMeta = modelMetaRef.value;
      let meta = valueMeta.value;
      if (!meta && modelMeta && "displayProp" in modelMeta) {
        meta = modelMeta.displayProp || null;
      }
      if (!meta) {
        throw Error(
          "Provided model has no $metadata property, and no specific value was provided via the 'for' component prop to c-display."
        );
      }
      if ("params" in meta) {
        throw Error("Cannot display a method");
      }
      if (modelMeta && "type" in modelMeta && (modelMeta == null ? void 0 : modelMeta.type) == "model") {
        const pkValue = model[modelMeta.keyProp.name];
        if (pkValue && meta.role == "collectionNavigation" && "foreignKey" in meta) {
          const narrowedMeta = meta;
          return h(
            resolveComponent("router-link"),
            {
              // Resolve to an href to allow overriding of admin routes in userspace.
              // If we just gave a named raw location, it would always use the coalesce admin route
              // instead of the user-overridden one (that the user overrides by declaring another
              // route with the same path).
              to: router.resolve({
                name: "coalesce-admin-list",
                params: { type: meta.itemType.typeDef.name },
                query: { ["filter." + meta.foreignKey.name]: pkValue }
              }).fullPath
            },
            // Use `propDisplay` for our formatted count, forcing the count always by preventing enumeration.
            () => {
              var _a;
              return propDisplay(model, narrowedMeta, {
                collection: { enumeratedItemsMax: 0 }
              }) || (((_a = model[narrowedMeta.name]) == null ? void 0 : _a.$hasLoaded) === false ? "View" : "None");
            }
          );
        }
        if (pkValue && meta.role == "referenceNavigation" && "foreignKey" in meta) {
          const narrowedMeta = meta;
          const fkValue = model[meta.foreignKey.name];
          if (fkValue) {
            return h(
              resolveComponent("router-link"),
              {
                // Resolve to an href to allow overriding of admin routes in userspace.
                // If we just gave a named raw location, it would always use the coalesce admin route
                // instead of the user-overridden one (that the user overrides by declaring another
                // route with the same path).
                to: router.resolve({
                  name: "coalesce-admin-item",
                  params: {
                    type: meta.typeDef.name,
                    id: model[meta.foreignKey.name]
                  }
                }).fullPath
              },
              () => propDisplay(model, narrowedMeta) ?? fkValue
            );
          }
        }
      }
      return h(_sfc_main$i, { ...props });
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(render);
    };
  }
});
function isPropReadOnly(p, model) {
  const metadata = model.$metadata;
  if (!metadata) return false;
  if ((metadata.behaviorFlags & (model.$primaryKey != null ? BehaviorFlags.Edit : BehaviorFlags.Create)) === 0) {
    return true;
  }
  if (p.createOnly) {
    if (model.$save.isLoading || model.$save.wasSuccessful || model.$load.isLoading || model.$load.wasSuccessful) {
      return true;
    }
    if (!model.$primaryKey || model.$getPropDirty(p.name)) {
      return false;
    }
    return true;
  }
  switch (p.role) {
    case "referenceNavigation":
      return p.foreignKey.dontSerialize;
    case "collectionNavigation":
      return false;
  }
  return p.dontSerialize;
}
const _sfc_main$9 = defineComponent({
  name: "c-admin-editor",
  setup() {
    const form = ref();
    watch(form, (form2) => {
      var _a;
      (_a = form2 == null ? void 0 : form2.validate) == null ? void 0 : _a.call(form2);
    });
    return { form, isPropReadOnly };
  },
  props: {
    model: {
      required: true,
      type: Object
    },
    color: { required: false, type: String, default: null },
    /** Whether or not a delete button is shown. Default true if the provided model allows deletes. */
    deletable: { required: false, type: Boolean, default: true }
  },
  methods: {
    propInputBinds(p) {
      let readonly = isPropReadOnly(p, this.model);
      return {
        readonly
      };
    },
    async deleteItemWithConfirmation() {
      if (confirm("Are you sure you wish to delete this item?")) {
        await this.model.$delete();
        this.$emit("deleted");
      }
    },
    async reload() {
      this.model.$save.wasSuccessful = null;
      this.model.$delete.wasSuccessful = null;
      this.model.$bulkSave.wasSuccessful = null;
      this.model.$load();
    }
  },
  computed: {
    metadata() {
      if (this.model) {
        return this.model.$metadata;
      }
      throw `No metadata available.`;
    },
    showContent() {
      const model = this.model;
      return (
        // If we have loaded at least once, we're in an edit scenario and the object is loaded.
        model.$load.wasSuccessful || // If we're not loading now, we're in a create scenario.
        !model.$load.isLoading
      );
    },
    hasPk() {
      return this.model.$primaryKey != null;
    },
    canEdit() {
      const metadata = this.metadata;
      if (!metadata) return false;
      return (metadata.behaviorFlags & (this.hasPk ? BehaviorFlags.Edit : BehaviorFlags.Create)) != 0;
    },
    canDelete() {
      var _a;
      return this.deletable && (((_a = this.metadata) == null ? void 0 : _a.behaviorFlags) & BehaviorFlags.Delete) != 0;
    },
    showProps() {
      if (!this.model) return [];
      return Object.values(this.metadata.props).filter(
        (p) => p.hidden === void 0 || (p.hidden & HiddenAreas.Edit) == 0
        // && (!p.dontSerialize || p.role == "referenceNavigation" || p.role == "collectionNavigation")
      );
    },
    isBulkSaveDirty() {
      return this.model.$bulkSavePreview().isDirty;
    }
  }
});
const _hoisted_1$5 = { key: 0 };
const _hoisted_2$5 = { key: 1 };
const _hoisted_3$4 = { key: 2 };
const _hoisted_4$4 = /* @__PURE__ */ createElementVNode("span", { class: "hidden-sm-and-down" }, "Save", -1);
const _hoisted_5$4 = /* @__PURE__ */ createElementVNode("span", { class: "hidden-sm-and-down" }, "Delete", -1);
const _hoisted_6$2 = /* @__PURE__ */ createElementVNode("span", { class: "hidden-sm-and-down" }, "Reload", -1);
const _hoisted_7$2 = {
  key: 0,
  class: "c-admin-page--description"
};
const _hoisted_8$1 = /* @__PURE__ */ createElementVNode("i", { class: "fa fa-info-circle" }, null, -1);
const _hoisted_9$1 = {
  key: 0,
  class: "fa fa-asterisk pr-1",
  title: "Field cannot be changed after save"
};
const _hoisted_10$1 = /* @__PURE__ */ createElementVNode("span", { class: "hidden-sm-and-down" }, "Save", -1);
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_toolbar_title = VToolbarTitle;
  const _component_v_divider = VDivider;
  const _component_c_display = _sfc_main$i;
  const _component_v_spacer = VSpacer;
  const _component_v_btn = VBtn;
  const _component_v_toolbar = VToolbar;
  const _component_v_col = VCol;
  const _component_c_admin_display = _sfc_main$a;
  const _component_c_input = _sfc_main$c;
  const _component_v_icon = VIcon;
  const _component_v_card = VCard;
  const _component_v_row = VRow;
  const _component_v_form = VForm;
  const _component_c_loader_status = _sfc_main$n;
  const _component_v_card_text = VCardText;
  const _component_v_card_actions = VCardActions;
  return openBlock(), createBlock(_component_v_card, {
    class: normalizeClass(["c-admin-editor", "type-" + _ctx.metadata.name])
  }, {
    default: withCtx(() => [
      createVNode(_component_v_toolbar, {
        class: "c-admin-editor--toolbar",
        density: "compact",
        color: _ctx.color,
        elevation: "4"
      }, {
        default: withCtx(() => [
          createVNode(_component_v_toolbar_title, { style: { "flex": "0 1 auto" } }, {
            default: withCtx(() => [
              _ctx.showContent ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                !_ctx.canEdit ? (openBlock(), createElementBlock("span", _hoisted_1$5, "View")) : !_ctx.hasPk ? (openBlock(), createElementBlock("span", _hoisted_2$5, "Create")) : (openBlock(), createElementBlock("span", _hoisted_3$4, "Edit"))
              ], 64)) : createCommentVNode("", true),
              createTextVNode(" " + toDisplayString(_ctx.metadata.displayName), 1)
            ]),
            _: 1
          }),
          createVNode(_component_v_divider, {
            class: "ml-4 my-0",
            vertical: ""
          }),
          _ctx.hasPk ? (openBlock(), createBlock(_component_v_toolbar_title, {
            key: 0,
            class: "hidden-xs"
          }, {
            default: withCtx(() => [
              createVNode(_component_c_display, { model: _ctx.model }, null, 8, ["model"])
            ]),
            _: 1
          })) : createCommentVNode("", true),
          createVNode(_component_v_spacer),
          !_ctx.model.$isAutoSaveEnabled ? (openBlock(), createBlock(_component_v_btn, {
            key: 1,
            onClick: _cache[0] || (_cache[0] = ($event) => _ctx.model.$bulkSave()),
            title: "Save",
            color: _ctx.isBulkSaveDirty ? "success" : void 0,
            variant: _ctx.isBulkSaveDirty ? "elevated" : "text",
            loading: _ctx.model.$bulkSave.isLoading,
            "prepend-icon": "fa fa-save"
          }, {
            default: withCtx(() => [
              _hoisted_4$4
            ]),
            _: 1
          }, 8, ["color", "variant", "loading"])) : createCommentVNode("", true),
          _ctx.canDelete ? (openBlock(), createBlock(_component_v_btn, {
            key: 2,
            onClick: _cache[1] || (_cache[1] = ($event) => _ctx.deleteItemWithConfirmation()),
            variant: "text",
            disabled: !_ctx.hasPk,
            title: "Delete",
            "prepend-icon": "fa fa-trash-alt"
          }, {
            default: withCtx(() => [
              _hoisted_5$4
            ]),
            _: 1
          }, 8, ["disabled"])) : createCommentVNode("", true),
          createVNode(_component_v_btn, {
            onClick: _ctx.reload,
            variant: "text",
            disabled: !_ctx.hasPk,
            title: "Reload",
            "prepend-icon": "$loading"
          }, {
            default: withCtx(() => [
              _hoisted_6$2
            ]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ]),
        _: 1
      }, 8, ["color"]),
      _ctx.metadata.description ? (openBlock(), createElementBlock("div", _hoisted_7$2, [
        _hoisted_8$1,
        createTextVNode(" " + toDisplayString(_ctx.metadata.displayName) + ": " + toDisplayString(_ctx.metadata.description), 1)
      ])) : createCommentVNode("", true),
      createVNode(_component_v_card_text, { class: "pt-2" }, {
        default: withCtx(() => [
          createVNode(_component_c_loader_status, {
            loaders: {
              [!_ctx.showContent ? "no-initial-content" : "no-error-content"]: [
                _ctx.model.$load
              ],
              "": [_ctx.model.$save, _ctx.model.$bulkSave, _ctx.model.$delete]
            }
          }, {
            default: withCtx(() => [
              createVNode(_component_v_form, { ref: "form" }, {
                default: withCtx(() => [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.showProps, (prop) => {
                    return openBlock(), createBlock(_component_v_row, {
                      key: prop.name,
                      class: normalizeClass(["c-admin-editor--row", "prop-" + prop.name]),
                      "no-gutters": ""
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_v_col, {
                          cols: "12",
                          md: "2",
                          class: "py-0 pr-3 py-md-3 font-weight-bold text-md-right c-admin-editor--label-col",
                          "align-self": "start"
                        }, {
                          default: withCtx(() => [
                            prop.createOnly && !_ctx.isPropReadOnly(prop, _ctx.model) ? (openBlock(), createElementBlock("i", _hoisted_9$1)) : createCommentVNode("", true),
                            createTextVNode(" " + toDisplayString(prop.displayName), 1)
                          ]),
                          _: 2
                        }, 1024),
                        createVNode(_component_v_col, {
                          class: "py-0",
                          "align-self": "start",
                          style: { "flex-basis": "1px" }
                        }, {
                          default: withCtx(() => [
                            createVNode(_component_v_row, {
                              "no-gutters": "",
                              style: { "min-height": "44px" },
                              "align-content": "center"
                            }, {
                              default: withCtx(() => [
                                createVNode(_component_v_col, { class: "c-admin-editor--input-col" }, {
                                  default: withCtx(() => [
                                    createVNode(_component_c_input, mergeProps({
                                      model: _ctx.model,
                                      for: prop,
                                      ref_for: true
                                    }, _ctx.propInputBinds(prop), {
                                      label: "",
                                      "aria-label": prop.displayName,
                                      "aria-description": prop.description,
                                      "hide-details": "auto",
                                      density: "compact",
                                      variant: "outlined",
                                      onDeleted: _cache[2] || (_cache[2] = ($event) => (
                                        // Reload when a c-select-many-to-many item is deleted,
                                        // since delete responses have no payloads and the delete
                                        // might have affected a computed property on the model
                                        _ctx.model.$load()
                                      ))
                                    }), {
                                      default: withCtx(() => [
                                        createVNode(_component_c_admin_display, {
                                          model: _ctx.model,
                                          for: prop
                                        }, null, 8, ["model", "for"])
                                      ]),
                                      _: 2
                                    }, 1040, ["model", "for", "aria-label", "aria-description"])
                                  ]),
                                  _: 2
                                }, 1024),
                                prop.role == "referenceNavigation" ? (openBlock(), createBlock(_component_v_col, {
                                  key: 0,
                                  class: "c-admin-editor--aux-col"
                                }, {
                                  default: withCtx(() => [
                                    createVNode(_component_v_btn, {
                                      class: "c-admin-editor--ref-nav-link",
                                      variant: "outlined",
                                      tabindex: "-1",
                                      title: "View selected item",
                                      disabled: !_ctx.model[prop.foreignKey.name],
                                      to: {
                                        name: "coalesce-admin-item",
                                        params: {
                                          type: prop.typeDef.name,
                                          id: _ctx.model[prop.foreignKey.name]
                                        }
                                      }
                                    }, {
                                      default: withCtx(() => [
                                        createVNode(_component_v_icon, null, {
                                          default: withCtx(() => [
                                            createTextVNode("fa fa-ellipsis-h")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["disabled", "to"])
                                  ]),
                                  _: 2
                                }, 1024)) : createCommentVNode("", true),
                                prop.type == "string" && (prop.subtype == "url" || prop.subtype == "email" || prop.subtype == "tel") ? (openBlock(), createBlock(_component_v_col, {
                                  key: 1,
                                  class: "c-admin-editor--aux-col"
                                }, {
                                  default: withCtx(() => [
                                    createVNode(_component_v_btn, {
                                      class: "c-admin-editor--href-link",
                                      variant: "outlined",
                                      tabindex: "-1",
                                      disabled: !_ctx.model[prop.name],
                                      href: (prop.subtype == "email" ? "mailto:" : prop.subtype == "tel" ? "tel:" : "") + _ctx.model[prop.name]
                                    }, {
                                      default: withCtx(() => [
                                        createVNode(_component_v_icon, { class: "black--text" }, {
                                          default: withCtx(() => [
                                            createTextVNode("fa fa-external-link-alt ")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["disabled", "href"])
                                  ]),
                                  _: 2
                                }, 1024)) : createCommentVNode("", true),
                                prop.type == "string" && prop.subtype == "url-image" ? (openBlock(), createBlock(_component_v_col, {
                                  key: 2,
                                  class: "c-admin-editor--aux-col"
                                }, {
                                  default: withCtx(() => [
                                    createVNode(_component_v_card, {
                                      outlined: "",
                                      rounded: "",
                                      class: "c-admin-editor--img-preview"
                                    }, {
                                      default: withCtx(() => [
                                        createVNode(_component_c_display, {
                                          model: _ctx.model,
                                          for: prop
                                        }, null, 8, ["model", "for"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)) : createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["class"]);
                  }), 128))
                ]),
                _: 1
              }, 512)
            ]),
            _: 1
          }, 8, ["loaders"])
        ]),
        _: 1
      }),
      _ctx.canEdit ? (openBlock(), createBlock(_component_v_card_actions, { key: 1 }, {
        default: withCtx(() => [
          createVNode(_component_v_spacer),
          !_ctx.model.$isAutoSaveEnabled ? (openBlock(), createBlock(_component_v_btn, {
            key: 0,
            onClick: _cache[3] || (_cache[3] = ($event) => _ctx.model.$bulkSave()),
            title: "Save",
            color: _ctx.isBulkSaveDirty ? "success" : void 0,
            variant: _ctx.isBulkSaveDirty ? "elevated" : "text",
            loading: _ctx.model.$bulkSave.isLoading,
            "prepend-icon": "fa fa-save"
          }, {
            default: withCtx(() => [
              _hoisted_10$1
            ]),
            _: 1
          }, 8, ["color", "variant", "loading"])) : (openBlock(), createBlock(_component_v_btn, {
            key: 1,
            disabled: "",
            "prepend-icon": "fa fa-save",
            loading: _ctx.model.$save.isLoading
          }, {
            default: withCtx(() => [
              createTextVNode(" Auto-save enabled ")
            ]),
            _: 1
          }, 8, ["loading"]))
        ]),
        _: 1
      })) : createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class"]);
}
const __unplugin_components_0$1 = /* @__PURE__ */ _export_sfc(_sfc_main$9, [["render", _sfc_render$4]]);
const _hoisted_1$4 = { class: "c-method" };
const _hoisted_2$4 = { key: 0 };
const _hoisted_3$3 = { key: 1 };
const _hoisted_4$3 = {
  key: 0,
  class: "c-method--result-success"
};
const _hoisted_5$3 = ["textContent"];
const _hoisted_6$1 = { key: 1 };
const _hoisted_7$1 = /* @__PURE__ */ createElementVNode("br", null, null, -1);
const _hoisted_8 = ["src", "alt"];
const _hoisted_9 = ["src", "alt"];
const _hoisted_10 = { key: 2 };
const _hoisted_11 = {
  key: 3,
  class: "c-method--result-null"
};
const _sfc_main$8 = /* @__PURE__ */ defineComponent({
  ...{
    name: "c-admin-method"
  },
  __name: "c-admin-method",
  props: {
    model: {},
    for: {},
    autoReloadModel: { type: Boolean }
  },
  setup(__props) {
    const resultDisplayOptions = {
      collection: {
        enumeratedItemsMax: Infinity,
        enumeratedItemsSeparator: "\n"
      }
    };
    const props = __props;
    const fileDownloadKind = ref("preview");
    const instance = getCurrentInstance();
    const methodMeta = computed(() => {
      const modelMeta = props.model.$metadata;
      const meta = typeof props.for == "string" ? modelMeta.methods[props.for] : props.for;
      if (meta && "params" in meta) {
        return meta;
      }
      throw Error("`c-method` requires metadata for a method.");
    });
    const filteredParams = computed(() => {
      return Object.values(methodMeta.value.params).filter((p) => !p.source);
    });
    const caller = computed(() => {
      const caller2 = viewModel.value[methodMeta.value.name];
      if (!caller2)
        throw Error(
          `Method '${methodMeta.value.name}' doesn't exist on provided model.`
        );
      return caller2;
    });
    const viewModel = computed(() => {
      if (props.model instanceof ViewModel) return props.model;
      if (props.model instanceof ListViewModel) return props.model;
      if (props.model instanceof ServiceViewModel) return props.model;
      throw Error("c-method: prop `model` is required, and must be a ViewModel.");
    });
    async function invoke() {
      fileDownloadKind.value = "preview";
      await caller.value.invokeWithArgs();
      if (props.autoReloadModel && "$load" in viewModel.value) {
        await viewModel.value.$load();
      }
      if (methodMeta.value.autoClear) {
        caller.value.resetArgs();
      }
    }
    async function invokeAndDownload() {
      fileDownloadKind.value = "download";
      await caller.value.invokeWithArgs();
      if (props.autoReloadModel && "$load" in viewModel.value) {
        viewModel.value.$load();
      }
      if (methodMeta.value.autoClear) {
        caller.value.resetArgs();
      }
      downloadFileResult();
    }
    function downloadFileResult() {
      const fileCaller = caller.value;
      const file = fileCaller.result;
      if (!(file instanceof File)) return;
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.href = fileCaller.getResultObjectUrl(instance.proxy);
      a.download = file.name;
      a.click();
      setTimeout(() => {
        document.body.removeChild(a);
      }, 1);
    }
    return (_ctx, _cache) => {
      const _component_v_col = VCol;
      const _component_c_input = _sfc_main$c;
      const _component_v_row = VRow;
      const _component_v_icon = VIcon;
      const _component_v_btn = VBtn;
      const _component_v_alert = VAlert;
      const _component_c_display = _sfc_main$i;
      const _component_c_loader_status = _sfc_main$n;
      return openBlock(), createElementBlock("div", _hoisted_1$4, [
        filteredParams.value.length ? (openBlock(), createBlock(_component_v_row, {
          key: 0,
          class: "my-0 c-method--section c-method--params"
        }, {
          default: withCtx(() => [
            createVNode(_component_v_col, null, {
              default: withCtx(() => [
                createTextVNode(" Parameters ")
              ]),
              _: 1
            }),
            createVNode(_component_v_col, { class: "py-0" }, {
              default: withCtx(() => [
                createVNode(_component_v_row, { class: "my-0" }, {
                  default: withCtx(() => [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(filteredParams.value, (param) => {
                      return openBlock(), createBlock(_component_v_col, {
                        key: param.name,
                        cols: "12",
                        sm: "6",
                        md: "4",
                        lg: "3"
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_c_input, {
                            model: caller.value,
                            for: param.name,
                            "hide-details": "auto",
                            density: "compact",
                            variant: "outlined"
                          }, null, 8, ["model", "for"])
                        ]),
                        _: 2
                      }, 1024);
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : createCommentVNode("", true),
        createVNode(_component_v_row, { class: "my-0 c-method--section c-method--results" }, {
          default: withCtx(() => [
            createVNode(_component_v_col, null, {
              default: withCtx(() => [
                methodMeta.value.return.type == "file" && !filteredParams.value.length ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                  createVNode(_component_v_btn, {
                    color: "primary",
                    onClick: invoke,
                    loading: caller.value.isLoading
                  }, {
                    default: withCtx(() => [
                      filteredParams.value.length ? (openBlock(), createElementBlock("span", _hoisted_2$4, "Execute")) : (openBlock(), createElementBlock("span", _hoisted_3$3, [
                        createVNode(_component_v_icon, { start: "" }, {
                          default: withCtx(() => [
                            createTextVNode("fa fa-search")
                          ]),
                          _: 1
                        }),
                        createTextVNode(" Preview ")
                      ]))
                    ]),
                    _: 1
                  }, 8, ["loading"]),
                  createVNode(_component_v_btn, {
                    class: "mt-1",
                    color: "primary",
                    onClick: invokeAndDownload,
                    loading: caller.value.isLoading
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_v_icon, { start: "" }, {
                        default: withCtx(() => [
                          createTextVNode("fa fa-download")
                        ]),
                        _: 1
                      }),
                      createTextVNode(" Download ")
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ], 64)) : (openBlock(), createBlock(_component_v_btn, {
                  key: 1,
                  color: "primary",
                  onClick: invoke,
                  loading: caller.value.isLoading,
                  sm: ""
                }, {
                  default: withCtx(() => [
                    createTextVNode(" Execute ")
                  ]),
                  _: 1
                }, 8, ["loading"]))
              ]),
              _: 1
            }),
            createVNode(_component_v_col, null, {
              default: withCtx(() => [
                createVNode(_component_c_loader_status, {
                  loaders: {
                    "no-initial-content no-error-content no-loading-content": [caller.value]
                  },
                  style: { "min-height": "55px" }
                }, {
                  default: withCtx(() => [
                    createElementVNode("h3", null, [
                      createTextVNode(" Result: "),
                      caller.value.result && methodMeta.value.return.type == "file" ? (openBlock(), createBlock(_component_v_btn, {
                        key: 0,
                        color: "primary",
                        onClick: downloadFileResult,
                        loading: caller.value.isLoading,
                        size: "x-small",
                        outlined: ""
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_v_icon, {
                            start: "",
                            small: ""
                          }, {
                            default: withCtx(() => [
                              createTextVNode("fa fa-download")
                            ]),
                            _: 1
                          }),
                          createTextVNode(" Save to Disk ")
                        ]),
                        _: 1
                      }, 8, ["loading"])) : createCommentVNode("", true)
                    ]),
                    caller.value.wasSuccessful && (methodMeta.value.return.type == "void" || caller.value.message) ? (openBlock(), createElementBlock("span", _hoisted_4$3, [
                      createVNode(_component_v_alert, {
                        type: "success",
                        dense: ""
                      }, {
                        default: withCtx(() => [
                          createElementVNode("span", {
                            class: "text-pre-wrap",
                            textContent: toDisplayString(caller.value.message || "Success")
                          }, null, 8, _hoisted_5$3)
                        ]),
                        _: 1
                      })
                    ])) : createCommentVNode("", true),
                    caller.value.result && methodMeta.value.return.type == "file" ? (openBlock(), createElementBlock("div", _hoisted_6$1, [
                      createElementVNode("pre", null, toDisplayString(caller.value.result.name) + " • " + toDisplayString(caller.value.result.type) + " • " + toDisplayString(caller.value.result.size.toLocaleString()) + " bytes", 1),
                      _hoisted_7$1,
                      fileDownloadKind.value == "preview" && "getResultObjectUrl" in caller.value ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                        caller.value.result.type.indexOf("image") >= 0 ? (openBlock(), createElementBlock("img", {
                          key: 0,
                          src: caller.value.getResultObjectUrl(unref(instance).proxy),
                          alt: caller.value.result.name,
                          class: "elevation-1",
                          style: { "max-width": "100%" }
                        }, null, 8, _hoisted_8)) : caller.value.result.type.indexOf("video") >= 0 ? (openBlock(), createElementBlock("video", {
                          key: 1,
                          src: caller.value.getResultObjectUrl(unref(instance).proxy),
                          alt: caller.value.result.name,
                          class: "elevation-1",
                          controls: "",
                          style: { "max-width": "100%" }
                        }, null, 8, _hoisted_9)) : (openBlock(), createElementBlock("pre", _hoisted_10, "Unable to show preview."))
                      ], 64)) : createCommentVNode("", true)
                    ])) : caller.value.result != null && methodMeta.value.return.type !== "void" ? (openBlock(), createBlock(_component_c_display, {
                      key: 2,
                      element: "pre",
                      class: "c-method--result-value",
                      modelValue: caller.value.result,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => caller.value.result = $event),
                      for: methodMeta.value.return,
                      options: resultDisplayOptions
                    }, null, 8, ["modelValue", "for"])) : caller.value.wasSuccessful != null && caller.value.result == null && methodMeta.value.return.type !== "void" ? (openBlock(), createElementBlock("span", _hoisted_11, [
                      createElementVNode("pre", null, toDisplayString("" + caller.value.result), 1)
                    ])) : createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["loaders"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]);
    };
  }
});
const _sfc_main$7 = defineComponent({
  name: "c-admin-methods",
  props: {
    model: {
      required: true,
      type: Object
    },
    area: {
      required: false,
      type: Number
    },
    color: { required: false, type: String, default: null },
    autoReloadModel: { required: false, type: Boolean, default: false }
  },
  computed: {
    viewModel() {
      if (this.model instanceof ViewModel) return this.model;
      if (this.model instanceof ListViewModel) return this.model;
      if (this.model instanceof ServiceViewModel) return this.model;
      throw Error(
        "c-method: prop `model` is required, and must be a ViewModel."
      );
    },
    metadata() {
      return this.viewModel.$metadata;
    },
    isStatic() {
      return this.viewModel instanceof ListViewModel;
    },
    methods() {
      if (this.viewModel instanceof ViewModel && !this.viewModel.$primaryKey) {
        return [];
      }
      return Object.values(this.metadata.methods).filter(
        (m) => !!m.isStatic == this.isStatic && (!this.area || ((m.hidden || 0) & this.area) == 0)
      );
    }
  }
});
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_toolbar_title = VToolbarTitle;
  const _component_v_divider = VDivider;
  const _component_c_display = _sfc_main$i;
  const _component_v_toolbar = VToolbar;
  const _component_v_expansion_panel_title = VExpansionPanelTitle;
  const _component_c_admin_method = _sfc_main$8;
  const _component_v_expansion_panel_text = VExpansionPanelText;
  const _component_v_expansion_panel = VExpansionPanel;
  const _component_v_expansion_panels = VExpansionPanels;
  const _component_v_card = VCard;
  return _ctx.methods.length ? (openBlock(), createBlock(_component_v_card, {
    key: 0,
    class: "c-admin-methods"
  }, {
    default: withCtx(() => [
      createVNode(_component_v_toolbar, {
        class: "c-admin-methods--toolbar",
        density: "compact",
        color: _ctx.color
      }, {
        default: withCtx(() => [
          createVNode(_component_v_toolbar_title, { style: { "flex": "0 1 auto" } }, {
            default: withCtx(() => [
              createTextVNode(" Actions ")
            ]),
            _: 1
          }),
          createVNode(_component_v_divider, {
            class: "mx-4 my-0",
            vertical: ""
          }),
          "$primaryKey" in _ctx.viewModel ? (openBlock(), createBlock(_component_v_toolbar_title, { key: 0 }, {
            default: withCtx(() => [
              createVNode(_component_c_display, { model: _ctx.viewModel }, null, 8, ["model"])
            ]),
            _: 1
          })) : createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["color"]),
      createVNode(_component_v_expansion_panels, { class: "c-methods" }, {
        default: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.methods, (method) => {
            return openBlock(), createBlock(_component_v_expansion_panel, {
              key: method.name,
              class: normalizeClass("method-" + method.name)
            }, {
              default: withCtx(() => [
                createVNode(_component_v_expansion_panel_title, null, {
                  default: withCtx(() => [
                    createElementVNode("div", null, toDisplayString(method.displayName), 1)
                  ]),
                  _: 2
                }, 1024),
                createVNode(_component_v_expansion_panel_text, null, {
                  default: withCtx(() => [
                    createVNode(_component_c_admin_method, {
                      model: _ctx.model,
                      for: method,
                      autoReloadModel: _ctx.autoReloadModel
                    }, null, 8, ["model", "for", "autoReloadModel"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["class"]);
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  })) : createCommentVNode("", true);
}
const __unplugin_components_1 = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["render", _sfc_render$3]]);
const _sfc_main$6 = defineComponent({
  name: "c-admin-editor-page",
  props: {
    type: { required: true, type: String },
    id: { required: false, type: [String, Number] },
    color: { required: false, type: String, default: null },
    autoSave: {
      required: false,
      type: [String, Boolean],
      default: "auto"
    }
  },
  setup(props) {
    if (!ViewModel.typeLookup[props.type]) {
      throw Error(
        `No model named ${props.type} is registered to ViewModel.typeLookup`
      );
    }
    const viewModel = new ViewModel.typeLookup[props.type]();
    viewModel.$includes = "admin-editor";
    const effectiveAutoSave = computed(() => {
      const value = props.autoSave;
      if (value == null || value == "auto") {
        const meta = viewModel.$metadata;
        for (const propName in meta.props) {
          const prop = meta.props[propName];
          if (prop.createOnly && !isPropReadOnly(prop, viewModel)) {
            return false;
          }
        }
        return true;
      }
      return value;
    });
    return {
      viewModel,
      HiddenAreas,
      effectiveAutoSave
    };
  },
  computed: {
    /** Support for common convention of exposing 'pageTitle' from router-view hosted components. */
    pageTitle() {
      if (this.isCreate) {
        return "Create - " + this.metadata.displayName;
      }
      let display = this.viewModel ? modelDisplay(this.viewModel) : null;
      if (!display) {
        return this.metadata.displayName;
      }
      const maxLen = 30;
      if (display.length <= maxLen) {
        return display + " - " + this.metadata.displayName;
      }
      return display.slice(0, maxLen) + "... - " + this.metadata.displayName;
    },
    metadata() {
      if (this.viewModel) {
        return this.viewModel.$metadata;
      }
      throw `No metadata available.`;
    },
    isCreate() {
      return !this.viewModel.$primaryKey;
    },
    hasInstanceMethods() {
      return !this.isCreate && this.metadata && Object.values(this.metadata.methods).some((m) => !m.isStatic);
    }
  },
  methods: {
    onDeleted() {
      this.$router.back();
    }
  },
  async created() {
    const params = mapQueryToParams(
      useRoute().query,
      ListParameters,
      this.metadata
    );
    this.viewModel.$dataSource = params.dataSource;
    if (this.id) {
      await this.viewModel.$load(this.id);
    } else {
      if (params.filter) {
        for (const propName in this.metadata.props) {
          const prop = this.metadata.props[propName];
          const filterValue = params.filter[propName];
          if (filterValue != null) {
            try {
              this.viewModel[propName] = mapValueToModel(
                filterValue,
                prop
              );
            } catch (e) {
              console.error(`Could not map filter parameter ${propName}. ${e}`);
            }
          }
        }
      }
      bindKeyToRouteOnCreate(
        this,
        this.viewModel,
        "id",
        /* keep the querystring in case it has data source parameters */
        true
      );
    }
    watch(
      () => this.effectiveAutoSave,
      (autoSave) => {
        if (autoSave) {
          this.viewModel.$startAutoSave(this, { wait: 500 });
        } else {
          this.viewModel.$stopAutoSave();
        }
      },
      { immediate: true }
    );
  }
});
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_c_admin_editor = __unplugin_components_0$1;
  const _component_c_admin_methods = __unplugin_components_1;
  const _component_v_container = VContainer;
  return openBlock(), createBlock(_component_v_container, {
    class: normalizeClass(["c-admin-editor-page", "type-" + _ctx.metadata.name])
  }, {
    default: withCtx(() => [
      createVNode(_component_c_admin_editor, {
        class: "c-admin-editor-page--editor",
        model: _ctx.viewModel,
        color: _ctx.color,
        onDeleted: _ctx.onDeleted
      }, null, 8, ["model", "color", "onDeleted"]),
      createVNode(_component_c_admin_methods, {
        class: "c-admin-editor-page--methods",
        model: _ctx.viewModel,
        area: _ctx.HiddenAreas.Edit,
        "auto-reload-model": "",
        color: _ctx.color
      }, null, 8, ["model", "area", "color"])
    ]),
    _: 1
  }, 8, ["class"]);
}
const cAdminEditorPage = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["render", _sfc_render$2]]);
const _hoisted_1$3 = ["onClick"];
const _hoisted_2$3 = ["onClick"];
const _sfc_main$5 = /* @__PURE__ */ defineComponent({
  __name: "c-table",
  props: {
    list: {},
    props: {},
    admin: { type: Boolean },
    editable: { type: Boolean },
    extraHeaders: {},
    loaders: {},
    tableProps: {}
  },
  emits: ["click:item"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const listVm = computed(() => props.list);
    const cTable = ref();
    const isHorizontalScrollbarVisible = ref(false);
    const checkHorizontalScrollbar = () => {
      const divElement = cTable.value;
      const tableElement = divElement == null ? void 0 : divElement.querySelector("table");
      if (tableElement && divElement) {
        isHorizontalScrollbarVisible.value = divElement.clientWidth < tableElement.clientWidth;
      }
    };
    const resizeObserver = new ResizeObserver(() => {
      checkHorizontalScrollbar();
    });
    onMounted(() => {
      if (cTable.value) {
        resizeObserver.observe(cTable.value);
      }
      checkHorizontalScrollbar();
    });
    onUnmounted(() => {
      resizeObserver.disconnect();
    });
    const metadata = computed(() => props.list.$metadata);
    const effectiveProps = computed(() => {
      var _a;
      if ((_a = props.props) == null ? void 0 : _a.length) {
        return props.props.map((propName) => metadata.value.props[propName]).filter((prop) => !!prop);
      }
      return Object.values(metadata.value.props).filter(
        (p) => p.hidden === void 0 || (p.hidden & HiddenAreas.List) == 0
      );
    });
    const headers = computed(() => {
      return [
        ...effectiveProps.value.map((o) => ({
          text: o.displayName,
          value: o.name,
          sortable: o.type != "collection",
          align: "left",
          prop: o.name,
          isFixed: false
        })),
        ...(props.extraHeaders || []).map((h2) => {
          if (typeof h2 === "string") {
            return {
              text: h2,
              value: h2,
              sortable: false,
              prop: void 0,
              isFixed: false
            };
          } else {
            return {
              text: h2.header,
              value: h2.header,
              sortable: false,
              prop: void 0,
              isFixed: h2.isFixed
            };
          }
        })
      ];
    });
    function orderByToggle(field) {
      const list = props.list;
      const params = list.$params;
      if (params.orderBy == field && !params.orderByDescending) {
        params.orderBy = null;
        params.orderByDescending = field;
      } else if (!params.orderBy && params.orderByDescending == field) {
        params.orderBy = null;
        params.orderByDescending = null;
      } else {
        params.orderBy = field;
        params.orderByDescending = null;
      }
    }
    function onRowClick(event, item) {
      if (props.editable) return;
      if (event.target instanceof HTMLElement && event.target.closest("a,button")) {
        return;
      }
      emit("click:item", item);
    }
    return (_ctx, _cache) => {
      const _component_v_icon = VIcon;
      const _component_c_admin_display = _sfc_main$a;
      const _component_c_display = _sfc_main$i;
      const _component_c_input = _sfc_main$c;
      const _component_c_loader_status = _sfc_main$n;
      return openBlock(), createElementBlock("div", {
        ref_key: "cTable",
        ref: cTable,
        class: normalizeClass(["c-table", { "c-table--editable": _ctx.editable }])
      }, [
        createVNode(_component_c_loader_status, {
          loaders: { "no-initial-content": [listVm.value.$load], ..._ctx.loaders }
        }, {
          default: withCtx(() => [
            createVNode(unref(VTable), mergeProps({ style: { "--v-table-header-height": "40px" } }, _ctx.tableProps), {
              default: withCtx(() => [
                createElementVNode("thead", null, [
                  createElementVNode("tr", null, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(headers.value, (header) => {
                      return openBlock(), createElementBlock("th", {
                        key: "header-" + header.value,
                        class: normalizeClass(["text-left", {
                          ["fixed-column-right"]: header.isFixed && isHorizontalScrollbarVisible.value,
                          sortable: header.sortable,
                          ["prop-" + header.prop]: !!header.prop,
                          ["th-" + header.value]: !header.prop
                        }]),
                        onClick: ($event) => header.sortable ? orderByToggle(header.value) : void 0
                      }, [
                        createTextVNode(toDisplayString(header.text) + " ", 1),
                        listVm.value.$params.orderBy == header.value ? (openBlock(), createBlock(_component_v_icon, { key: 0 }, {
                          default: withCtx(() => [
                            createTextVNode(" fa fa-caret-up ")
                          ]),
                          _: 1
                        })) : listVm.value.$params.orderByDescending == header.value ? (openBlock(), createBlock(_component_v_icon, { key: 1 }, {
                          default: withCtx(() => [
                            createTextVNode(" fa fa-caret-down ")
                          ]),
                          _: 1
                        })) : createCommentVNode("", true)
                      ], 10, _hoisted_1$3);
                    }), 128))
                  ])
                ]),
                createElementVNode("tbody", null, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(listVm.value.$modelOnlyMode ? listVm.value.$modelItems : listVm.value.$items, (item, index) => {
                    return openBlock(), createElementBlock("tr", {
                      key: index,
                      onClick: ($event) => onRowClick($event, item)
                    }, [
                      renderSlot(_ctx.$slots, "item-prepend", { item }),
                      (openBlock(true), createElementBlock(Fragment, null, renderList(effectiveProps.value, (prop) => {
                        return openBlock(), createElementBlock("td", {
                          key: prop.name,
                          class: normalizeClass([["prop-" + prop.name], "text-xs-left"])
                        }, [
                          _ctx.editable && !unref(isPropReadOnly)(prop, item) ? (openBlock(), createBlock(_component_c_input, {
                            key: 0,
                            model: item,
                            for: prop,
                            label: "",
                            "hide-details": "auto",
                            hint: "",
                            density: "compact",
                            variant: "outlined",
                            rows: "1",
                            "auto-grow": "",
                            "validate-on": "eager"
                          }, {
                            default: withCtx(() => [
                              _ctx.admin ? (openBlock(), createBlock(_component_c_admin_display, {
                                key: 0,
                                model: item,
                                for: prop
                              }, null, 8, ["model", "for"])) : (openBlock(), createBlock(_component_c_display, {
                                key: 1,
                                model: item,
                                for: prop
                              }, null, 8, ["model", "for"]))
                            ]),
                            _: 2
                          }, 1032, ["model", "for"])) : _ctx.admin ? (openBlock(), createBlock(_component_c_admin_display, {
                            key: 1,
                            model: item,
                            for: prop
                          }, null, 8, ["model", "for"])) : (openBlock(), createBlock(_component_c_display, {
                            key: 2,
                            model: item,
                            for: prop
                          }, null, 8, ["model", "for"]))
                        ], 2);
                      }), 128)),
                      renderSlot(_ctx.$slots, "item-append", {
                        item,
                        isHorizontalScrollbarVisible: isHorizontalScrollbarVisible.value
                      })
                    ], 8, _hoisted_2$3);
                  }), 128))
                ])
              ]),
              _: 3
            }, 16)
          ]),
          _: 3
        }, 8, ["loaders"])
      ], 2);
    };
  }
});
const filterTypes = ["string", "number", "boolean", "enum", "date"];
const _sfc_main$4 = defineComponent({
  name: "c-list-filters",
  props: {
    list: { required: true, type: Object }
  },
  methods: {
    removeFilter(filterInfo) {
      delete this.list.$params.filter[filterInfo.key];
    },
    addFilter(filterInfo) {
      var _a;
      if (((_a = filterInfo.propMeta) == null ? void 0 : _a.type) == "boolean") {
        filterInfo.value = true;
      } else {
        filterInfo.value = "";
      }
    }
  },
  computed: {
    filters() {
      const list = this.list;
      const filter = this.list.$params.filter ?? {};
      const meta = this.list.$metadata;
      const filterNames = Object.values(meta.props).filter((p) => filterTypes.includes(p.type) && !p.dontSerialize).map((p) => p.name);
      for (const key in filter) {
        if (!filterNames.includes(key)) filterNames.push(key);
      }
      return filterNames.map((key) => {
        var _a;
        const value = filter[key];
        const propMeta = meta.props[key] ?? null;
        return {
          key,
          get value() {
            if (propMeta.type == "boolean") {
              if (value === "true") return true;
              if (value === "false") return false;
            }
            if (((propMeta == null ? void 0 : propMeta.type) == "enum" || (propMeta == null ? void 0 : propMeta.type) == "number") && propMeta.role == "value") {
              return String(filter[key]).split(",").filter((v) => v !== "").map((v) => isNaN(v) ? v : +v);
            }
            return filter[key];
          },
          set value(value2) {
            var _a2;
            if (Array.isArray(value2)) {
              value2 = value2.join(",");
            }
            ((_a2 = list.$params).filter ?? (_a2.filter = {}))[key] = value2;
          },
          propMeta,
          isNull: value === null || value === "null",
          isDefined: key in filter,
          // Both undefined and emptystring are considered by Coalesce to be "not filtered".
          // `null` as a value is a filter that checks that the value is `null`.
          isActive: value !== "" && value !== void 0,
          displayName: ((propMeta == null ? void 0 : propMeta.role) == "foreignKey" ? (_a = propMeta.navigationProp) == null ? void 0 : _a.displayName : void 0) ?? (propMeta == null ? void 0 : propMeta.displayName) ?? key
        };
      }).sort(
        (a, b) => (
          // a.isActive != b.isActive ? (b.isActive ? 1 : -1) :
          a.displayName.localeCompare(b.displayName)
        )
      );
    },
    definedFilters() {
      return this.filters.filter((info) => info.isDefined);
    },
    undefinedFilters() {
      return this.filters.filter((info) => !info.isDefined);
    },
    activeFilters() {
      return this.filters.filter((info) => info.isActive);
    },
    activeCount() {
      return this.activeFilters.length;
    }
  }
});
const _hoisted_1$2 = /* @__PURE__ */ createElementVNode("span", { class: "hidden-sm-and-down" }, "Filters", -1);
const _hoisted_2$2 = {
  key: 0,
  class: "text-grey"
};
const _hoisted_3$2 = { class: "" };
const _hoisted_4$2 = /* @__PURE__ */ createElementVNode("i", { class: "fa fa-times" }, null, -1);
const _hoisted_5$2 = /* @__PURE__ */ createElementVNode("pre", null, "null", -1);
const _hoisted_6 = /* @__PURE__ */ createElementVNode("i", { class: "fa fa-ellipsis-h" }, null, -1);
const _hoisted_7 = {
  key: 0,
  class: "pl-5 py-2"
};
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_icon = VIcon;
  const _component_v_badge = VBadge;
  const _component_v_btn = VBtn;
  const _component_v_card_title = VCardTitle;
  const _component_v_btn_toggle = VBtnToggle;
  const _component_v_col = VCol;
  const _component_c_select = _sfc_main$h;
  const _component_v_select = VSelect;
  const _component_v_combobox = VCombobox;
  const _component_v_switch = VSwitch;
  const _component_v_text_field = VTextField;
  const _component_v_row = VRow;
  const _component_v_card_text = VCardText;
  const _component_v_chip = VChip;
  const _component_v_card = VCard;
  const _component_v_menu = VMenu;
  return openBlock(), createBlock(_component_v_menu, {
    class: "c-list-filters--menu",
    "close-on-content-click": false,
    "offset-y": ""
  }, {
    activator: withCtx(({ props }) => [
      createVNode(_component_v_btn, mergeProps({
        class: "c-list-filters",
        variant: "text"
      }, props), {
        default: withCtx(() => [
          createVNode(_component_v_badge, {
            "model-value": !!_ctx.activeCount,
            location: "top start",
            floating: "",
            content: _ctx.activeCount,
            color: "accent"
          }, {
            default: withCtx(() => [
              createVNode(_component_v_icon, {
                start: _ctx.$vuetify.display.mdAndUp
              }, {
                default: withCtx(() => [
                  createTextVNode("fa fa-filter")
                ]),
                _: 1
              }, 8, ["start"])
            ]),
            _: 1
          }, 8, ["model-value", "content"]),
          _hoisted_1$2
        ]),
        _: 2
      }, 1040)
    ]),
    default: withCtx(() => [
      createVNode(_component_v_card, { class: "c-list-filters--card" }, {
        default: withCtx(() => [
          createVNode(_component_v_card_title, null, {
            default: withCtx(() => [
              createTextVNode(" Active Filters ")
            ]),
            _: 1
          }),
          createVNode(_component_v_card_text, null, {
            default: withCtx(() => [
              !_ctx.definedFilters.length ? (openBlock(), createElementBlock("div", _hoisted_2$2, "No Filters")) : createCommentVNode("", true),
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.definedFilters, (filter) => {
                return openBlock(), createBlock(_component_v_row, {
                  key: filter.key,
                  "no-gutters": "",
                  "align-items": "center",
                  align: "center",
                  class: "py-2"
                }, {
                  default: withCtx(() => [
                    createVNode(_component_v_col, {
                      class: "flex-grow-0 pr-4",
                      style: { "max-width": "170px" }
                    }, {
                      default: withCtx(() => [
                        createElementVNode("span", _hoisted_3$2, toDisplayString(filter.displayName), 1),
                        createVNode(_component_v_btn_toggle, {
                          class: "text-no-wrap",
                          variant: "outlined",
                          density: "compact",
                          modelValue: filter.isNull ? 1 : filter.isDefined && !filter.isNull ? 2 : null
                        }, {
                          default: withCtx(() => [
                            createVNode(_component_v_btn, {
                              size: "x-small",
                              onClick: ($event) => _ctx.removeFilter(filter),
                              title: "Remove Filter"
                            }, {
                              default: withCtx(() => [
                                _hoisted_4$2
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            createVNode(_component_v_btn, {
                              size: "x-small",
                              onClick: ($event) => filter.value = null,
                              title: "Filter where value is null"
                            }, {
                              default: withCtx(() => [
                                _hoisted_5$2
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            createVNode(_component_v_btn, {
                              size: "x-small",
                              onClick: ($event) => filter.value = "",
                              title: "Set custom filter value"
                            }, {
                              default: withCtx(() => [
                                _hoisted_6
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1032, ["modelValue"])
                      ]),
                      _: 2
                    }, 1024),
                    createVNode(_component_v_col, { "align-self": "end" }, {
                      default: withCtx(() => [
                        filter.isNull ? (openBlock(), createElementBlock("pre", _hoisted_7, "== null")) : filter.propMeta && (filter.propMeta.role == "foreignKey" || filter.propMeta.role == "primaryKey") && (!filter.value || filter.value.toString().indexOf(",") == -1) ? (openBlock(), createBlock(_component_c_select, {
                          key: 1,
                          keyValue: filter.value,
                          "onUpdate:keyValue": ($event) => filter.value = $event,
                          for: filter.propMeta.role == "primaryKey" ? _ctx.list.$metadata.name : filter.propMeta.navigationProp ?? filter.propMeta.principalType,
                          clearable: "",
                          "hide-details": "",
                          density: "compact"
                        }, null, 8, ["keyValue", "onUpdate:keyValue", "for"])) : filter.propMeta && filter.propMeta.type == "enum" ? (openBlock(), createBlock(_component_v_select, {
                          key: 2,
                          modelValue: filter.value,
                          "onUpdate:modelValue": ($event) => filter.value = $event,
                          items: filter.propMeta.typeDef.values,
                          "item-title": "displayName",
                          "item-value": "value",
                          label: filter.displayName,
                          clearable: "",
                          "hide-details": "",
                          multiple: "",
                          density: "compact"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "label"])) : filter.propMeta && filter.propMeta.type == "number" ? (openBlock(), createBlock(_component_v_combobox, {
                          key: 3,
                          modelValue: filter.value,
                          "onUpdate:modelValue": ($event) => filter.value = $event,
                          label: filter.displayName,
                          clearable: "",
                          "hide-details": "",
                          "disable-lookup": "",
                          multiple: "",
                          chips: "",
                          "deletable-chips": "",
                          "small-chips": ""
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])) : filter.propMeta && filter.propMeta.type == "boolean" ? (openBlock(), createBlock(_component_v_switch, {
                          key: 4,
                          modelValue: filter.value,
                          "onUpdate:modelValue": ($event) => filter.value = $event,
                          label: filter.displayName,
                          clearable: "",
                          "hide-details": ""
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])) : (openBlock(), createBlock(_component_v_text_field, {
                          key: 5,
                          modelValue: filter.value,
                          "onUpdate:modelValue": ($event) => filter.value = $event,
                          label: filter.displayName,
                          density: "compact",
                          variant: "outlined",
                          clearable: "",
                          "hide-details": ""
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024);
              }), 128))
            ]),
            _: 1
          }),
          createVNode(_component_v_card_title, null, {
            default: withCtx(() => [
              createTextVNode(" Add Filters ")
            ]),
            _: 1
          }),
          createVNode(_component_v_card_text, { class: "d-flex ga-1 flex-wrap" }, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.undefinedFilters, (filter) => {
                return openBlock(), createBlock(_component_v_chip, {
                  key: filter.key,
                  small: "",
                  onClick: ($event) => _ctx.addFilter(filter)
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(filter.displayName), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]);
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  });
}
const __unplugin_components_8 = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["render", _sfc_render$1]]);
function useAdminTable(list) {
  const metadata = computed(() => unref(list).$metadata);
  const canCreate = computed(() => {
    const meta = metadata.value;
    return meta && (meta.behaviorFlags & BehaviorFlags.Create) != 0 && !unref(list).$modelOnlyMode;
  });
  const canEdit = computed(() => {
    const meta = metadata.value;
    return meta && (meta.behaviorFlags & BehaviorFlags.Edit) != 0 && !unref(list).$modelOnlyMode;
  });
  const canDelete = computed(() => {
    const meta = metadata.value;
    return meta && (meta.behaviorFlags & BehaviorFlags.Delete) != 0 && !unref(list).$modelOnlyMode;
  });
  const hasInstanceMethods = computed(() => {
    const meta = metadata.value;
    return meta && Object.values(meta.methods).some((m) => !m.isStatic) && !unref(list).$modelOnlyMode;
  });
  const router = useRouter();
  function getItemRoute(item) {
    return router.resolve({
      name: "coalesce-admin-item",
      params: {
        type: metadata.value.name,
        id: item == null ? void 0 : item.$primaryKey
      },
      query: Object.fromEntries(
        Object.entries(mapParamsToDto(unref(list).$params) || {}).filter(
          (entry) => entry[0].startsWith("filter.") || entry[0].startsWith("dataSource")
        )
      )
    }).fullPath;
  }
  return {
    metadata,
    canCreate,
    canEdit,
    canDelete,
    hasInstanceMethods,
    getItemRoute
  };
}
const _hoisted_1$1 = /* @__PURE__ */ createElementVNode("span", { class: "hidden-sm-and-down" }, "Create", -1);
const _hoisted_2$1 = /* @__PURE__ */ createElementVNode("span", { class: "hidden-sm-and-down" }, "Reload", -1);
const _hoisted_3$1 = /* @__PURE__ */ createElementVNode("span", { class: "hidden-sm-and-down" }, "Edit", -1);
const _hoisted_4$1 = /* @__PURE__ */ createElementVNode("span", { class: "hidden-sm-and-down" }, "Lock", -1);
const _hoisted_5$1 = {
  key: 2,
  class: "c-admin-table-toolbar--range hidden-sm-and-down"
};
const _sfc_main$3 = /* @__PURE__ */ defineComponent({
  __name: "c-admin-table-toolbar",
  props: /* @__PURE__ */ mergeModels({
    list: { required: true, type: Object },
    pageSizes: { required: false, type: Array },
    color: { required: false, type: String, default: null }
  }, {
    "editable": { type: Boolean, ...{
      default: null,
      required: false
    } },
    "editableModifiers": {}
  }),
  emits: ["update:editable"],
  setup(__props) {
    const props = __props;
    const editable = useModel(__props, "editable");
    const { metadata, canCreate, getItemRoute } = useAdminTable(
      toRef(props, "list")
    );
    return (_ctx, _cache) => {
      const _component_v_toolbar_title = VToolbarTitle;
      const _component_v_divider = VDivider;
      const _component_v_icon = VIcon;
      const _component_v_btn = VBtn;
      const _component_v_spacer = VSpacer;
      const _component_c_list_range_display = __unplugin_components_5;
      const _component_c_list_page = _sfc_main$m;
      const _component_v_text_field = VTextField;
      const _component_c_list_filters = __unplugin_components_8;
      const _component_c_list_page_size = __unplugin_components_9;
      const _component_v_toolbar = VToolbar;
      return openBlock(), createBlock(_component_v_toolbar, {
        extended: "",
        class: "c-admin-table-toolbar",
        density: "comfortable",
        color: __props.color,
        elevation: "4"
      }, {
        extension: withCtx(() => [
          createVNode(_component_v_text_field, {
            class: "c-admin-table-toolbar--search",
            "hide-details": "",
            "prepend-inner-icon": "fa fa-search",
            label: "Search",
            modelValue: __props.list.$params.search,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => __props.list.$params.search = $event),
            density: "comfortable",
            "single-line": "",
            clearable: ""
          }, null, 8, ["modelValue"]),
          createVNode(_component_v_divider, {
            class: "hidden-xs-only mx-4 my-0",
            vertical: ""
          }),
          createVNode(_component_c_list_filters, { list: __props.list }, null, 8, ["list"]),
          createVNode(_component_v_spacer),
          createVNode(_component_c_list_page_size, {
            list: __props.list,
            items: __props.pageSizes
          }, null, 8, ["list", "items"])
        ]),
        default: withCtx(() => [
          createVNode(_component_v_toolbar_title, { class: "c-admin-table-toolbar--model-name hidden-xs-only" }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(metadata).displayName), 1)
            ]),
            _: 1
          }),
          createVNode(_component_v_divider, {
            class: "hidden-xs-only mx-4",
            vertical: ""
          }),
          unref(canCreate) ? (openBlock(), createBlock(_component_v_btn, {
            key: 0,
            class: "c-admin-table-toolbar--button-create",
            variant: "text",
            to: unref(getItemRoute)()
          }, {
            default: withCtx(() => [
              createVNode(_component_v_icon, {
                start: _ctx.$vuetify.display.mdAndUp
              }, {
                default: withCtx(() => [
                  createTextVNode("$plus")
                ]),
                _: 1
              }, 8, ["start"]),
              _hoisted_1$1
            ]),
            _: 1
          }, 8, ["to"])) : createCommentVNode("", true),
          createVNode(_component_v_btn, {
            class: "c-admin-table-toolbar--button-reload",
            variant: "text",
            onClick: _cache[0] || (_cache[0] = ($event) => __props.list.$load())
          }, {
            default: withCtx(() => [
              createVNode(_component_v_icon, { start: "" }, {
                default: withCtx(() => [
                  createTextVNode("$loading")
                ]),
                _: 1
              }),
              _hoisted_2$1
            ]),
            _: 1
          }),
          editable.value !== null ? (openBlock(), createBlock(_component_v_btn, {
            key: 1,
            class: "c-admin-table-toolbar--button-editable",
            variant: "text",
            onClick: _cache[1] || (_cache[1] = ($event) => editable.value = !editable.value),
            title: editable.value ? "Make Read-only" : "Make Editable"
          }, {
            default: withCtx(() => [
              !editable.value ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                createVNode(_component_v_icon, { start: "" }, {
                  default: withCtx(() => [
                    createTextVNode("$edit")
                  ]),
                  _: 1
                }),
                _hoisted_3$1
              ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                createVNode(_component_v_icon, { start: "" }, {
                  default: withCtx(() => [
                    createTextVNode("fa fa-lock")
                  ]),
                  _: 1
                }),
                _hoisted_4$1
              ], 64))
            ]),
            _: 1
          }, 8, ["title"])) : createCommentVNode("", true),
          createVNode(_component_v_spacer),
          __props.list ? (openBlock(), createElementBlock("span", _hoisted_5$1, [
            createTextVNode(" Showing "),
            createVNode(_component_c_list_range_display, { list: __props.list }, null, 8, ["list"])
          ])) : createCommentVNode("", true),
          createVNode(_component_v_spacer),
          createVNode(_component_c_list_page, {
            class: "c-admin-table-toolbar--page",
            list: __props.list
          }, null, 8, ["list"])
        ]),
        _: 1
      }, 8, ["color"]);
    };
  }
});
const _sfc_main$2 = defineComponent({
  name: "c-admin-table",
  props: {
    list: { required: true, type: Object },
    pageSizes: { required: false, type: Array },
    color: { required: false, type: String, default: null },
    queryBind: { type: Boolean, default: false },
    autoSave: {
      required: false,
      type: [String, Boolean],
      default: "auto"
    }
  },
  setup(props) {
    const tableProps = useAdminTable(toRef(props, "list"));
    const editable = ref(false);
    const effectiveAutoSave = computed(() => {
      if (!editable.value) return false;
      const value = props.autoSave;
      if (value == null || value == "auto") {
        const meta = tableProps.metadata.value;
        for (const propName in meta.props) {
          if (meta.props[propName].createOnly) {
            return false;
          }
        }
        return true;
      }
      return value;
    });
    return {
      router: useRouter(),
      ...tableProps,
      editable,
      effectiveAutoSave
    };
  },
  computed: {
    viewModel() {
      if (this.list instanceof ListViewModel) return this.list;
      throw Error(
        "c-admin-table: prop `list` is required, and must be a ListViewModel."
      );
    }
  },
  methods: {
    async deleteItemWithConfirmation(item) {
      if (confirm("Are you sure you wish to delete this item?")) {
        await item.$delete();
        await this.viewModel.$load();
      }
    },
    addItem() {
      const viewModel = new ViewModel.typeLookup[this.metadata.name]();
      viewModel.$params = this.list.$params;
      this.list.$items.push(viewModel);
    }
  },
  created() {
    if (this.queryBind) {
      bindToQueryString(this, this, "editable", { parse: (v) => v === "true" });
      const baselineParams = mapParamsToDto(this.viewModel.$params);
      this.$watch(
        () => mapParamsToDto(this.viewModel.$params),
        (mappedParams, old) => {
          for (const key in baselineParams) {
            if (mappedParams[key] == baselineParams[key]) {
              delete mappedParams[key];
            }
          }
          this.router.replace({
            query: {
              // First, take all existing query params so that any that aren't handled
              // by mapQueryToParams/mapParamsToDto don't get lost
              ...this.router.currentRoute.value.query,
              // Next, set all previous query-mapped params to undefined
              // so that any that aren't in the new mappedParams object get unset
              ...typeof old == "object" ? Object.fromEntries(
                Object.entries(old).map((e) => [e[0], void 0])
              ) : {},
              // Then layer on any new params, overwriting any that got set to undefined previously.
              ...mappedParams
            }
          }).catch((err) => {
            if (err.name === "NavigationDuplicated") return;
            throw err;
          });
        },
        { deep: true }
      );
      this.$watch(
        () => this.router.currentRoute.value.query,
        (v) => {
          this.viewModel.$params = mapQueryToParams(
            {
              ...baselineParams,
              // Overlay the query values on top of the baseline parameters.
              ...v
            },
            ListParameters,
            this.viewModel.$metadata
          );
        },
        { immediate: true }
      );
    }
    this.$watch(
      () => this.effectiveAutoSave,
      (effectiveAutoSave) => {
        if (effectiveAutoSave && !this.viewModel.$isAutoSaveEnabled) {
          this.viewModel.$startAutoSave(this, { wait: 500 });
        } else if (!effectiveAutoSave && this.viewModel.$isAutoSaveEnabled) {
          this.viewModel.$stopAutoSave();
        }
      },
      { immediate: true }
    );
    this.viewModel.$load.setConcurrency("debounce");
    this.viewModel.$startAutoLoad(this, { wait: 0 });
    this.viewModel.$load();
  }
});
const _hoisted_1 = {
  key: 0,
  class: "c-admin-page--description"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("i", { class: "fa fa-info-circle" }, null, -1);
const _hoisted_3 = {
  class: "d-flex flex-nowrap text-no-wrap ga-1",
  "no-gutters": ""
};
const _hoisted_4 = /* @__PURE__ */ createElementVNode("i", {
  "aria-hidden": "true",
  class: "v-icon notranslate fa fa-save"
}, null, -1);
const _hoisted_5 = /* @__PURE__ */ createElementVNode("i", {
  "aria-hidden": "true",
  class: "v-icon notranslate fa fa-trash-alt"
}, null, -1);
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_c_admin_table_toolbar = _sfc_main$3;
  const _component_v_btn = VBtn;
  const _component_c_table = _sfc_main$5;
  const _component_c_list_pagination = __unplugin_components_3;
  const _component_v_card_text = VCardText;
  const _component_v_card = VCard;
  return openBlock(), createBlock(_component_v_card, {
    class: normalizeClass(["c-admin-table", "type-" + _ctx.metadata.name])
  }, {
    default: withCtx(() => [
      createVNode(_component_c_admin_table_toolbar, {
        list: _ctx.viewModel,
        "page-sizes": _ctx.pageSizes,
        "onUpdate:editable": _cache[0] || (_cache[0] = ($event) => _ctx.editable = $event),
        editable: _ctx.canEdit ? _ctx.editable : void 0,
        color: _ctx.color
      }, null, 8, ["list", "page-sizes", "editable", "color"]),
      _ctx.metadata.description ? (openBlock(), createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        createTextVNode(" " + toDisplayString(_ctx.metadata.displayName) + ": " + toDisplayString(_ctx.metadata.description), 1)
      ])) : createCommentVNode("", true),
      createVNode(_component_v_card_text, null, {
        default: withCtx(() => [
          createVNode(_component_c_table, {
            admin: "",
            editable: _ctx.editable,
            list: _ctx.viewModel,
            "extra-headers": [{ header: "Actions", isFixed: true }],
            loaders: {
              "": _ctx.list.$modelOnlyMode ? [] : [
                ..._ctx.viewModel.$items.map((i) => i.$delete),
                ...!_ctx.editable ? [] : _ctx.viewModel.$items.flatMap((i) => [i.$save, i.$bulkSave])
              ]
            },
            "onClick:item": _cache[1] || (_cache[1] = (item) => _ctx.$router.push(_ctx.getItemRoute(item)))
          }, {
            "item-append": withCtx(({ item, isHorizontalScrollbarVisible }) => [
              createElementVNode("td", {
                width: "1%",
                class: normalizeClass([{ ["fixed-column-right"]: isHorizontalScrollbarVisible }, "c-admin-table--actions"])
              }, [
                createElementVNode("div", _hoisted_3, [
                  _ctx.editable && !_ctx.effectiveAutoSave ? (openBlock(), createBlock(_component_v_btn, {
                    key: 0,
                    title: "Save",
                    color: "success",
                    variant: item.$bulkSavePreview().isDirty ? "elevated" : "text",
                    loading: item.$bulkSave.isLoading,
                    icon: "",
                    onClick: ($event) => item.$bulkSave()
                  }, {
                    default: withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 2
                  }, 1032, ["variant", "loading", "onClick"])) : createCommentVNode("", true),
                  createVNode(_component_v_btn, {
                    title: _ctx.canEdit || _ctx.hasInstanceMethods ? "Edit" : "View",
                    variant: "text",
                    icon: "",
                    to: _ctx.getItemRoute(item)
                  }, {
                    default: withCtx(() => [
                      createElementVNode("i", {
                        "aria-hidden": "true",
                        class: normalizeClass([
                          "v-icon notranslate fa",
                          _ctx.canEdit || _ctx.hasInstanceMethods ? "fa-edit" : "fa-ellipsis-h"
                        ])
                      }, null, 2)
                    ]),
                    _: 2
                  }, 1032, ["title", "to"]),
                  _ctx.canDelete ? (openBlock(), createBlock(_component_v_btn, {
                    key: 1,
                    title: "Delete",
                    variant: "text",
                    icon: "",
                    onClick: ($event) => _ctx.deleteItemWithConfirmation(item),
                    loading: item.$delete.isLoading
                  }, {
                    default: withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 2
                  }, 1032, ["onClick", "loading"])) : createCommentVNode("", true)
                ])
              ], 2)
            ]),
            _: 1
          }, 8, ["editable", "list", "loaders"]),
          _ctx.editable && _ctx.canCreate ? (openBlock(), createBlock(_component_v_btn, {
            key: 0,
            onClick: _ctx.addItem,
            "prepend-icon": "fa fa-plus",
            color: _ctx.color,
            class: "my-2"
          }, {
            default: withCtx(() => [
              createTextVNode(" Add Item ")
            ]),
            _: 1
          }, 8, ["onClick", "color"])) : createCommentVNode("", true),
          createVNode(_component_c_list_pagination, {
            list: _ctx.list,
            "page-sizes": _ctx.pageSizes,
            class: "mt-4"
          }, null, 8, ["list", "page-sizes"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]);
}
const __unplugin_components_0 = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render]]);
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "c-admin-table-page",
  props: {
    type: { required: false, type: String, default: null },
    color: { required: false, type: String, default: null },
    list: { required: false, type: Object },
    autoSave: {
      required: false,
      type: [String, Boolean],
      default: "auto"
    }
  },
  setup(__props, { expose: __expose }) {
    const props = __props;
    const listVM = ref();
    watch(
      () => props.list,
      (list) => {
        if (list) {
          listVM.value = list;
          return;
        }
        if (!props.type) {
          throw Error(
            "c-admin-table-page: If prop `list` is not provided, `type` is required."
          );
        } else if (!ListViewModel.typeLookup[props.type]) {
          throw Error(
            `No model named ${props.type} is registered to ListViewModel.typeLookup`
          );
        }
        listVM.value = new ListViewModel.typeLookup[props.type]();
        listVM.value.$includes = "admin-list";
      },
      { immediate: true }
    );
    const metadata = computed(() => {
      if (listVM.value) {
        return listVM.value.$metadata;
      }
      throw `No metadata available - no list provided, and couldn't create one.`;
    });
    const pageTitle = computed(() => {
      return metadata.value.displayName + " List";
    });
    __expose({ pageTitle });
    return (_ctx, _cache) => {
      const _component_c_admin_table = __unplugin_components_0;
      const _component_c_admin_methods = __unplugin_components_1;
      const _component_v_container = VContainer;
      return openBlock(), createBlock(_component_v_container, {
        fluid: "",
        class: normalizeClass(["c-admin-table-page", "type-" + metadata.value.name])
      }, {
        default: withCtx(() => [
          createVNode(_component_c_admin_table, {
            class: "c-admin-table-page--table",
            list: listVM.value,
            color: __props.color,
            autoSave: __props.autoSave,
            "page-sizes": [10, 25, 100, 500],
            "query-bind": ""
          }, null, 8, ["list", "color", "autoSave"]),
          createVNode(_component_c_admin_methods, {
            class: "c-admin-table-page--methods",
            model: listVM.value,
            area: unref(HiddenAreas).List,
            color: __props.color,
            "auto-reload-model": ""
          }, null, 8, ["model", "area", "color"])
        ]),
        _: 1
      }, 8, ["class"]);
    };
  }
});
const MODEL_REQUIRED_MESSAGE = "c-select-string-value requires a model to be provided via the `model` prop, or a type to be provided via the `for` prop.";
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    name: "c-select-string-value",
    // We manually pass attrs via inputBindAttrs, so disable the default Vue behavior.
    // If we don't do this, some HTML attrs (e.g. tabindex) will incorrectly be placed
    // on the root element rather than on the search field in Vuetify component.
    inheritAttrs: false
  },
  __name: "c-select-string-value",
  props: /* @__PURE__ */ mergeModels({
    model: {},
    for: {},
    method: {},
    params: {},
    listWhenEmpty: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props) {
    const props = __props;
    const modelValue = useModel(__props, "modelValue");
    const menu = ref(false);
    const focused = ref(false);
    const { inputBindAttrs, valueMeta, modelMeta, valueOwner } = useMetadataProps(props);
    const methodOwner = computed(() => {
      var _a;
      if (modelMeta.value && typeof props.method == "string" && modelMeta.value.type == "model") {
        return modelMeta.value;
      }
      if (((_a = valueMeta.value) == null ? void 0 : _a.type) == "model") {
        return valueMeta.value.typeDef;
      }
      throw Error(MODEL_REQUIRED_MESSAGE);
    });
    const methodMeta = computed(() => {
      let method;
      if (typeof props.method == "object") {
        method = props.method;
      } else {
        method = methodOwner.value.methods[props.method];
      }
      if (!method.isStatic || method.transportType != "item" || method.return.type != "collection" || method.return.itemType.type != "string") {
        throw Error(
          "c-select-string-value requires a static model method that returns an array of strings."
        );
      }
      return method;
    });
    const caller = new ModelApiClient(methodOwner.value).$useSimultaneousRequestCaching().$makeCaller("item", (c, page, search2) => {
      return c.$invoke(methodMeta.value, {
        page,
        search: search2,
        ...props.params
      });
    }).setConcurrency("debounce");
    const search = ref();
    watch(search, (newVal, oldVal) => {
      if (!newVal && !props.listWhenEmpty) {
        return;
      }
      if (newVal != oldVal) {
        caller(1, newVal).then(() => {
          if (focused.value) {
            menu.value = true;
          }
        });
      }
    });
    const loading = computed(() => {
      return caller.isLoading;
    });
    const items = computed(() => {
      if (!search.value && !props.listWhenEmpty) return [];
      return caller.result || [];
    });
    const internalValue = computed(() => {
      if (valueOwner.value && valueMeta.value) {
        return valueOwner.value[valueMeta.value.name];
      }
      return modelValue.value ?? null;
    });
    function onInput(value) {
      if (valueOwner.value && valueMeta.value) {
        valueOwner.value[valueMeta.value.name] = value;
      }
      modelValue.value = value || null;
    }
    onMounted(() => caller());
    return (_ctx, _cache) => {
      const _component_v_combobox = VCombobox;
      return openBlock(), createBlock(_component_v_combobox, mergeProps({
        class: "c-select-string-value",
        modelValue: internalValue.value ?? void 0,
        "onUpdate:modelValue": onInput,
        loading: loading.value,
        items: items.value,
        "hide-no-data": !_ctx.listWhenEmpty,
        search: search.value,
        "onUpdate:search": _cache[0] || (_cache[0] = ($event) => search.value = $event),
        menu: menu.value,
        "onUpdate:menu": _cache[1] || (_cache[1] = ($event) => menu.value = $event),
        focused: focused.value,
        "onUpdate:focused": _cache[2] || (_cache[2] = ($event) => focused.value = $event)
      }, unref(inputBindAttrs)), null, 16, ["modelValue", "loading", "items", "hide-no-data", "search", "menu", "focused"]);
    };
  }
});
const createCoalesceVuetify = (options) => {
  return {
    install(app) {
      const { metadata, components = {} } = options;
      for (const key in components) {
        app.component(key, components[key]);
      }
      app.provide(metadataKey, metadata);
      app.mixin({
        computed: {
          $coalesce() {
            return {
              metadata
            };
          }
        }
      });
    }
  };
};
export {
  _sfc_main$b as CAdminAuditLogPage,
  _sfc_main$a as CAdminDisplay,
  __unplugin_components_0$1 as CAdminEditor,
  cAdminEditorPage as CAdminEditorPage,
  _sfc_main$8 as CAdminMethod,
  __unplugin_components_1 as CAdminMethods,
  __unplugin_components_0 as CAdminTable,
  _sfc_main$1 as CAdminTablePage,
  _sfc_main$3 as CAdminTableToolbar,
  _sfc_main$d as CDatetimePicker,
  _sfc_main$i as CDisplay,
  _sfc_main$c as CInput,
  __unplugin_components_8 as CListFilters,
  _sfc_main$m as CListPage,
  __unplugin_components_9 as CListPageSize,
  __unplugin_components_3 as CListPagination,
  __unplugin_components_5 as CListRangeDisplay,
  _sfc_main$n as CLoaderStatus,
  _sfc_main$h as CSelect,
  _sfc_main$g as CSelectManyToMany,
  _sfc_main as CSelectStringValue,
  _sfc_main$f as CSelectValues,
  _sfc_main$5 as CTable,
  createCoalesceVuetify,
  isPropReadOnly,
  useMetadata
};
//# sourceMappingURL=coalesce-vue-vuetify3.js.map
